var _rect, _rect2, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileConfirmation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 161,
    viewBox: "0 0 320 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 160,
    transform: "translate(0.687988 0.334961)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.687988,
    y: 0.334961,
    width: 320,
    height: 160,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 321,
    height: 161
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.687988,
    y: 0.334961,
    width: 320,
    height: 160,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.451 143.597H147.992C147.721 143.597 147.501 143.376 147.501 143.103V34.0568C147.501 33.9045 147.571 33.76 147.692 33.6669L154.422 28.4386C154.598 28.3004 154.845 28.3004 155.022 28.4386L161.752 33.6669C161.872 33.76 161.942 33.9045 161.942 34.0568V143.103C161.942 143.376 161.723 143.597 161.451 143.597ZM147.01 143.597H130.902H130.282H118.127H117.909H108.467H106.767H97.2043H94.6123H91.7385H88.3738H79.3011C79.0304 143.597 78.8101 143.376 78.8101 143.103C78.8101 143.376 78.5905 143.597 78.3191 143.597H63.0079C62.7372 143.597 62.5169 143.376 62.5169 143.103V78.8954C62.5169 78.6225 62.7372 78.4019 63.0079 78.4019H78.3191C78.5905 78.4019 78.8101 78.6225 78.8101 78.8954V59.8651C78.8101 59.5929 79.0304 59.3723 79.3011 59.3723H87.8821V54.0565C87.8821 53.7837 88.1024 53.563 88.3738 53.563H97.2043C97.4758 53.563 97.6954 53.7837 97.6954 54.0565V79.0279H106.276V51.1145C106.276 50.9925 106.321 50.8748 106.403 50.7846L112.082 44.4543C112.277 44.2371 112.617 44.2371 112.812 44.4543L118.491 50.7846C118.573 50.8748 118.618 50.9925 118.618 51.1145V83.8608H129.791V44.5417C129.791 44.2689 130.01 44.0475 130.282 44.0475H147.01C147.281 44.0475 147.501 44.2689 147.501 44.5417V143.103C147.501 143.376 147.281 143.597 147.01 143.597ZM-3.72894 142.023H-6.321C-6.59177 142.023 -6.81201 141.802 -6.81201 141.529V52.4826C-6.81201 52.2097 -6.59177 51.9884 -6.321 51.9884H2.51021C2.78166 51.9884 3.00122 52.2097 3.00122 52.4826V57.7976H11.5822C11.8537 57.7976 12.0732 58.019 12.0732 58.2911V141.529C12.0732 141.802 11.8537 142.023 11.5822 142.023H2.51021H-3.72894ZM12.5643 142.023H27.8755C28.1469 142.023 28.3665 141.802 28.3665 141.529V77.3214C28.3665 77.0486 28.1469 76.8279 27.8755 76.8279H12.5643C12.2936 76.8279 12.0733 77.0486 12.0733 77.3214V141.529C12.0733 141.802 12.2936 142.023 12.5643 142.023ZM40.9753 143.597H32.088C31.8166 143.597 31.597 143.376 31.597 143.103V110.32C31.597 110.047 31.8166 109.826 32.088 109.826H40.4843V82.3006C40.4843 82.0277 40.7038 81.8071 40.9753 81.8071H46.0051V69.7916C46.0051 69.676 46.0458 69.5639 46.1194 69.475L51.7387 62.7281C51.9344 62.4926 52.2957 62.4926 52.4913 62.7281L58.1106 69.475C58.1843 69.5639 58.225 69.676 58.225 69.7916V143.103C58.225 143.376 58.0054 143.597 57.734 143.597H52.2132H46.4961H43.3259H40.9753ZM185.931 144.264H172.577V143.59C172.551 143.595 172.524 143.597 172.496 143.597H162.434C162.163 143.597 161.943 143.376 161.943 143.103V51.3415C161.943 51.0694 162.163 50.848 162.434 50.848H172.496C172.768 50.848 172.987 51.0694 172.987 51.3415V68.2573H184.032V61.6685C184.032 61.3956 184.252 61.175 184.523 61.175H194.586C194.858 61.175 195.077 61.3956 195.077 61.6685V143.103C195.077 143.376 194.858 143.597 194.586 143.597H185.931V144.264ZM219.186 147.335H219.587C219.654 147.335 219.719 147.321 219.778 147.296C219.836 147.321 219.901 147.335 219.969 147.335H236.697C236.968 147.335 237.188 147.114 237.188 146.841V48.2798C237.188 48.007 236.968 47.7863 236.697 47.7863H219.969C219.697 47.7863 219.478 48.007 219.478 48.2798V64.9131H210.88C210.609 64.9131 210.389 65.1337 210.389 65.4066V87.5989H207.827C207.555 87.5989 207.336 87.8195 207.336 88.0924V146.841C207.336 147.114 207.555 147.335 207.827 147.335H210.88H219.186Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72715 127.341C37.8557 125.995 74.4032 126.174 110.856 126.167C150.334 126.158 189.811 126.15 229.288 126.142C252.793 126.137 276.945 126.16 298.83 128.225C320.716 130.29 340.126 134.895 341.871 140.539C342.805 143.553 338.737 146.512 334.725 149.376C330.984 152.046 327.243 154.715 323.503 157.385C319.639 160.142 315.744 162.916 309.925 165.466C302.03 168.927 290.625 171.92 276.982 174.111C253.508 177.881 224.744 179.154 196.719 179.947C153.858 181.159 110.548 181.45 67.4744 180.814C38.677 180.39 9.15632 179.491 -16.1487 176.154C-47.886 171.969 -86.272 163.664 -93.8577 153.771C-98.5062 147.71 -103.212 139.246 -84.0999 134.633C-66.3093 130.338 -37.256 129.224 -14.7189 128.066C-9.24791 127.785 -3.76547 127.545 1.72715 127.341",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.43 158.753C178.233 157.102 166.532 155.97 153.563 155.601C153.18 155.59 152.791 155.583 152.406 155.573C157.984 154.303 161.483 152.782 161.483 151.133C161.483 147.788 146.737 144.473 129.578 142.936C129.244 142.925 128.905 142.918 128.569 142.908C126.386 141.346 124.786 139.656 124.786 137.892C124.786 133.268 138.435 128.961 142.136 126.394C139.251 126.328 104.191 126.047 94.3657 127.006C86.1422 129.562 84.4094 134.08 84.4094 137.952C84.4094 144.148 97.4191 149.411 115.529 151.331C108.758 155.598 74.2225 161.768 86.7116 162.403C86.7996 162.407 86.9851 162.396 87.2419 162.372C83.0122 164.034 80.6333 165.906 80.6333 167.887C80.6333 168.864 81.2123 169.817 82.3109 170.731C87.5159 175.064 104.351 178.523 126.046 179.787C126.969 179.84 127.9 179.89 128.84 179.936C130.559 180.02 132.305 180.089 134.076 180.145C134.997 180.174 135.923 180.2 136.857 180.221C139.298 180.276 141.78 180.305 144.297 180.305C179.458 180.305 207.962 174.745 207.962 167.887C207.962 164.274 200.053 161.024 187.43 158.753",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.249 180.221C139.315 180.2 138.388 180.175 137.467 180.145C135.697 180.089 133.95 180.02 132.231 179.937C131.291 179.89 130.36 179.84 129.437 179.787C107.743 178.523 90.9076 175.064 85.7021 170.731C84.604 169.818 84.0245 168.864 84.0245 167.887C84.0245 165.906 86.4034 164.034 90.6336 162.372C90.3762 162.395 90.1913 162.407 90.1028 162.403C77.6142 161.768 112.149 155.598 118.92 151.331C100.81 149.411 87.8006 144.148 87.8006 137.951C87.8006 134.081 89.5339 129.562 97.7574 127.006C103.307 126.465 116.904 126.319 128.209 126.306C116.383 126.293 100.484 126.409 94.3657 127.006C86.1422 129.562 84.4094 134.081 84.4094 137.951C84.4094 144.148 97.4191 149.411 115.529 151.331C108.758 155.598 74.2225 161.768 86.7116 162.403C86.7996 162.407 86.9851 162.395 87.2419 162.372C83.0122 164.034 80.6333 165.906 80.6333 167.887C80.6333 168.864 81.2123 169.818 82.3109 170.731C87.5159 175.064 104.351 178.523 126.046 179.787C126.969 179.84 127.9 179.89 128.84 179.937C130.559 180.02 132.305 180.089 134.076 180.145C134.997 180.175 135.923 180.2 136.857 180.221C139.298 180.276 141.78 180.305 144.297 180.305C144.998 180.305 145.694 180.302 146.389 180.298C144.318 180.289 142.266 180.266 140.249 180.221",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.292 129.777C18.3054 129.769 18.3187 129.761 18.332 129.753C19.5068 129.069 17.03 128.339 14.3737 128.572C14.0003 128.605 13.6354 128.641 13.2838 128.679C10.6021 128.969 7.63555 129.337 4.95385 129.043C4.09067 128.949 3.46995 128.745 3.11958 128.51C2.10849 127.832 -0.234965 127.368 -2.93849 127.376H-2.95788C-5.11706 127.382 -6.22635 126.667 -4.65637 126.267C-2.00135 125.592 3.03957 125.367 7.09848 125.374C44.8132 125.44 214.509 125.08 227.158 125.077C267.901 125.066 308.659 126.173 348.6 128.376C354.247 128.688 360.04 129.04 364.791 129.923C367.315 130.393 369.49 131.05 370.819 131.792C372.269 132.601 367.837 133.209 366.206 132.426C364.644 131.675 363.208 130.844 360.515 130.463C356.99 129.964 352.76 130.766 351.62 131.73C350.111 133.008 344.353 133.519 340.612 132.633C340.03 132.495 339.511 132.337 339.079 132.161C337.487 131.514 336.346 130.564 333.476 130.531C329.739 130.488 328.914 132.001 325.834 132.572C321.821 133.316 316.869 132.18 313.042 131.363C306.509 129.967 298.167 129.372 290.019 128.914C253.25 126.849 215.369 126.89 177.846 127.13C133.203 127.417 117.527 127.68 72.8971 128.195C66.7735 128.265 57.19 128.024 32.8389 130.177C29.0782 130.51 25.3927 130.939 21.4393 131.001C19.0267 131.039 17.3003 130.371 18.292 129.777",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.166 58.6379C200.152 58.6216 200.125 58.6385 200.136 58.6581L205.865 69.6798C206.024 69.9841 205.802 70.3477 205.46 70.3477H188.061C187.809 70.3477 187.604 70.552 187.604 70.8047V136.53C187.604 136.783 187.809 136.987 188.061 136.987H210.349C210.359 136.987 210.366 136.979 210.366 136.969C210.366 136.969 210.266 73.6582 210.259 69.9403C210.259 69.8287 210.217 69.7236 210.144 69.6407L200.172 58.4473",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 28,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.81201 217.422H241.063V28.2725H-1.81201V217.422Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.413 136.987H206.177V70.3477H183.413V136.987Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.413 136.987H206.177V70.3477L200.171 58.4473H190.332L183.413 70.3477V136.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 114.356H200.476C200.728 114.356 200.932 114.151 200.932 113.899V111.491C200.932 111.239 200.728 111.034 200.476 111.034H198.409C198.156 111.034 197.952 111.239 197.952 111.491V113.899C197.952 114.151 198.156 114.356 198.409 114.356",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 114.356H195.865C196.117 114.356 196.322 114.151 196.322 113.899V111.491C196.322 111.239 196.117 111.034 195.865 111.034H193.799C193.546 111.034 193.342 111.239 193.342 111.491V113.899C193.342 114.151 193.546 114.356 193.799 114.356",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 114.356H191.255C191.507 114.356 191.712 114.151 191.712 113.899V111.491C191.712 111.239 191.507 111.034 191.255 111.034H189.188C188.935 111.034 188.731 111.239 188.731 111.491V113.899C188.731 114.151 188.935 114.356 189.188 114.356",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 107.747H200.476C200.728 107.747 200.932 107.543 200.932 107.29V104.883C200.932 104.631 200.728 104.426 200.476 104.426H198.409C198.156 104.426 197.952 104.631 197.952 104.883V107.29C197.952 107.543 198.156 107.747 198.409 107.747",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 107.747H195.865C196.117 107.747 196.322 107.543 196.322 107.29V104.883C196.322 104.631 196.117 104.426 195.865 104.426H193.799C193.546 104.426 193.342 104.631 193.342 104.883V107.29C193.342 107.543 193.546 107.747 193.799 107.747",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 107.747H191.255C191.507 107.747 191.712 107.543 191.712 107.29V104.883C191.712 104.631 191.507 104.426 191.255 104.426H189.188C188.935 104.426 188.731 104.631 188.731 104.883V107.29C188.731 107.543 188.935 107.747 189.188 107.747",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 101.139H200.476C200.728 101.139 200.932 100.935 200.932 100.682V98.2744C200.932 98.0224 200.728 97.8174 200.476 97.8174H198.409C198.156 97.8174 197.952 98.0224 197.952 98.2744V100.682C197.952 100.935 198.156 101.139 198.409 101.139",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 101.139H195.865C196.117 101.139 196.322 100.935 196.322 100.682V98.2744C196.322 98.0224 196.117 97.8174 195.865 97.8174H193.799C193.546 97.8174 193.342 98.0224 193.342 98.2744V100.682C193.342 100.935 193.546 101.139 193.799 101.139",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 101.139H191.255C191.507 101.139 191.712 100.935 191.712 100.682V98.2744C191.712 98.0224 191.507 97.8174 191.255 97.8174H189.188C188.935 97.8174 188.731 98.0224 188.731 98.2744V100.682C188.731 100.935 188.935 101.139 189.188 101.139",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 94.5306H200.476C200.728 94.5306 200.932 94.3262 200.932 94.0736V91.666C200.932 91.414 200.728 91.209 200.476 91.209H198.409C198.156 91.209 197.952 91.414 197.952 91.666V94.0736C197.952 94.3262 198.156 94.5306 198.409 94.5306",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 94.5306H195.865C196.117 94.5306 196.322 94.3262 196.322 94.0736V91.666C196.322 91.414 196.117 91.209 195.865 91.209H193.799C193.546 91.209 193.342 91.414 193.342 91.666V94.0736C193.342 94.3262 193.546 94.5306 193.799 94.5306",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 94.5306H191.255C191.507 94.5306 191.712 94.3262 191.712 94.0736V91.666C191.712 91.414 191.507 91.209 191.255 91.209H189.188C188.935 91.209 188.731 91.414 188.731 91.666V94.0736C188.731 94.3262 188.935 94.5306 189.188 94.5306",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 87.9225H200.476C200.728 87.9225 200.932 87.7182 200.932 87.4655V85.0579C200.932 84.8059 200.728 84.6016 200.476 84.6016H198.409C198.156 84.6016 197.952 84.8059 197.952 85.0579V87.4655C197.952 87.7182 198.156 87.9225 198.409 87.9225",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 87.9225H195.865C196.117 87.9225 196.322 87.7182 196.322 87.4655V85.0579C196.322 84.8059 196.117 84.6016 195.865 84.6016H193.799C193.546 84.6016 193.342 84.8059 193.342 85.0579V87.4655C193.342 87.7182 193.546 87.9225 193.799 87.9225",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 87.9225H191.255C191.507 87.9225 191.712 87.7182 191.712 87.4655V85.0579C191.712 84.8059 191.507 84.6016 191.255 84.6016H189.188C188.935 84.6016 188.731 84.8059 188.731 85.0579V87.4655C188.731 87.7182 188.935 87.9225 189.188 87.9225",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.409 81.3141H200.476C200.728 81.3141 200.932 81.1098 200.932 80.8571V78.4495C200.932 78.1975 200.728 77.9932 200.476 77.9932H198.409C198.156 77.9932 197.952 78.1975 197.952 78.4495V80.8571C197.952 81.1098 198.156 81.3141 198.409 81.3141",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.799 81.3141H195.865C196.117 81.3141 196.322 81.1098 196.322 80.8571V78.4495C196.322 78.1975 196.117 77.9932 195.865 77.9932H193.799C193.546 77.9932 193.342 78.1975 193.342 78.4495V80.8571C193.342 81.1098 193.546 81.3141 193.799 81.3141",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.188 81.3141H191.255C191.507 81.3141 191.712 81.1098 191.712 80.8571V78.4495C191.712 78.1975 191.507 77.9932 191.255 77.9932H189.188C188.935 77.9932 188.731 78.1975 188.731 78.4495V80.8571C188.731 81.1098 188.935 81.3141 189.188 81.3141",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.431 136.987H204.28C204.533 136.987 204.737 136.783 204.737 136.53V70.456C204.737 70.3849 204.721 70.3144 204.688 70.2504L198.859 58.6986C198.781 58.5445 198.624 58.4473 198.452 58.4473H189.156C188.993 58.4473 188.843 58.5341 188.76 58.6744L182.036 70.2413C181.996 70.3111 181.974 70.3901 181.974 70.4704V136.53C181.974 136.783 182.178 136.987 182.431 136.987Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.21 70.5904L202.182 70.3201C202.53 70.3201 202.75 69.9461 202.581 69.6419L197.583 60.6263C197.503 60.4807 197.35 60.3906 197.184 60.3906H191.271C191.092 60.3906 190.93 60.4951 190.855 60.6576L185.795 69.9435C185.657 70.2464 185.878 70.5904 186.21 70.5904",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.113 66.4246H227.24C226.988 66.4246 226.783 66.2203 226.783 65.9676V56.0087C226.783 55.7567 226.988 55.5518 227.24 55.5518H229.113C229.366 55.5518 229.57 55.7567 229.57 56.0087V65.9676C229.57 66.2203 229.366 66.4246 229.113 66.4246",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.167 90.2358H230.746C230.369 90.2358 230.062 89.9296 230.062 89.5529V66.6191C230.062 66.2417 230.369 65.9355 230.746 65.9355H232.167C232.544 65.9355 232.849 66.2417 232.849 66.6191V89.5529C232.849 89.9296 232.544 90.2358 232.167 90.2358",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.691 114.284H235.27C234.893 114.284 234.587 113.978 234.587 113.601V90.6672C234.587 90.2899 234.893 89.9844 235.27 89.9844H236.691C237.068 89.9844 237.374 90.2899 237.374 90.6672V113.601C237.374 113.978 237.068 114.284 236.691 114.284",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 114,
    width: 4,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.276 114.078H241.063V143.604H238.276V114.078Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.31 143.604H239.029C238.613 143.604 238.276 143.267 238.276 142.851V114.831C238.276 114.416 238.613 114.078 239.029 114.078H240.31C240.726 114.078 241.063 114.416 241.063 114.831V142.851C241.063 143.267 240.726 143.604 240.31 143.604",
    fill: "#0A2A49"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.291 114.03C234.544 114.03 234.748 113.826 234.748 113.573V89.9882H230.209C230.46 89.9882 230.665 89.7832 230.665 89.5312V65.9478H227.266C227.518 65.9478 227.723 65.7428 227.723 65.4901V55.5332H215.556V65.4901C215.556 65.7428 215.761 65.9478 216.013 65.9478H212.629V89.5312C212.629 89.7832 212.48 90.342 212.732 90.342H207.313L207.667 113.573C207.667 113.826 207.871 114.52 208.124 114.52H203.326V143.577H238.875V114.03H234.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.453 48.2891V55.5165H223.841V48.2891",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.866 48.5V41.5336C222.866 41.281 222.662 41.0767 222.409 41.0767H222.098C222.273 41.0127 222.4 40.8482 222.4 40.651V33.8799H220.894V40.651C220.894 40.8482 221.021 41.0127 221.196 41.0767H220.884C220.632 41.0767 220.427 41.281 220.427 41.5336V48.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.413 34.2779V28.6094",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.045 144.037H234.14C234.393 144.037 234.597 143.832 234.597 143.58V132.569C234.597 132.316 234.393 132.111 234.14 132.111H232.045C231.792 132.111 231.588 132.316 231.588 132.569V143.58C231.588 143.832 231.792 144.037 232.045 144.037",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 144.037H229.059C229.311 144.037 229.516 143.832 229.516 143.58V132.569C229.516 132.316 229.311 132.111 229.059 132.111H226.963C226.71 132.111 226.506 132.316 226.506 132.569V143.58C226.506 143.832 226.71 144.037 226.963 144.037",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 144.037H223.977C224.23 144.037 224.434 143.832 224.434 143.58V132.569C224.434 132.316 224.23 132.111 223.977 132.111H221.881C221.629 132.111 221.424 132.316 221.424 132.569V143.58C221.424 143.832 221.629 144.037 221.881 144.037",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 28,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.81201 217.422H241.063V28.2725H-1.81201V217.422Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.343 144.037H219.353V132.111H216.343V144.037Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 144.037H213.813C214.066 144.037 214.271 143.832 214.271 143.58V132.569C214.271 132.316 214.066 132.111 213.813 132.111H211.718C211.466 132.111 211.261 132.316 211.261 132.569V143.58C211.261 143.832 211.466 144.037 211.718 144.037",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.636 144.037H208.732C208.984 144.037 209.189 143.832 209.189 143.58V132.569C209.189 132.316 208.984 132.111 208.732 132.111H206.636C206.384 132.111 206.179 132.316 206.179 132.569V143.58C206.179 143.832 206.384 144.037 206.636 144.037",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.045 127.903H234.14C234.393 127.903 234.597 127.698 234.597 127.446V125.231C234.597 124.979 234.393 124.774 234.14 124.774H232.045C231.792 124.774 231.588 124.979 231.588 125.231V127.446C231.588 127.698 231.792 127.903 232.045 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 127.903H229.516V124.774H226.506V127.446C226.506 127.698 226.71 127.903 226.963 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 127.903H224.434V124.774H221.424V127.446C221.424 127.698 221.629 127.903 221.881 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.8 127.903H218.895C219.148 127.903 219.353 127.698 219.353 127.446V125.231C219.353 124.979 219.148 124.774 218.895 124.774H216.8C216.547 124.774 216.343 124.979 216.343 125.231V127.446C216.343 127.698 216.547 127.903 216.8 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 127.903H213.813C214.066 127.903 214.271 127.698 214.271 127.446V125.231C214.271 124.979 214.066 124.774 213.813 124.774H211.718C211.466 124.774 211.261 124.979 211.261 125.231V127.446C211.261 127.698 211.466 127.903 211.718 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.636 127.903H208.732C208.984 127.903 209.189 127.698 209.189 127.446V125.231C209.189 124.979 208.984 124.774 208.732 124.774H206.636C206.384 124.774 206.179 124.979 206.179 125.231V127.446C206.179 127.698 206.384 127.903 206.636 127.903",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.045 121.617H234.14C234.393 121.617 234.597 121.412 234.597 121.16V118.946C234.597 118.693 234.393 118.488 234.14 118.488H232.045C231.792 118.488 231.588 118.693 231.588 118.946V121.16C231.588 121.412 231.792 121.617 232.045 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 121.617H229.059C229.311 121.617 229.516 121.412 229.516 121.16V118.946C229.516 118.693 229.311 118.488 229.059 118.488H226.963C226.71 118.488 226.506 118.693 226.506 118.946V121.16C226.506 121.412 226.71 121.617 226.963 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 121.617H223.977C224.23 121.617 224.434 121.412 224.434 121.16V118.946C224.434 118.693 224.23 118.488 223.977 118.488H221.881C221.629 118.488 221.424 118.693 221.424 118.946V121.16C221.424 121.412 221.629 121.617 221.881 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.8 121.617H218.895C219.148 121.617 219.353 121.412 219.353 121.16V118.946C219.353 118.693 219.148 118.488 218.895 118.488H216.8C216.547 118.488 216.343 118.693 216.343 118.946V121.16C216.343 121.412 216.547 121.617 216.8 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 121.617H213.813C214.066 121.617 214.271 121.412 214.271 121.16V118.946C214.271 118.693 214.066 118.488 213.813 118.488H211.718C211.466 118.488 211.261 118.693 211.261 118.946V121.16C211.261 121.412 211.466 121.617 211.718 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.636 121.617H208.732C208.984 121.617 209.189 121.412 209.189 121.16V118.946C209.189 118.693 208.984 118.488 208.732 118.488H206.636C206.384 118.488 206.179 118.693 206.179 118.946V121.16C206.179 121.412 206.384 121.617 206.636 121.617",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 111.713H229.059C229.311 111.713 229.516 111.509 229.516 111.256V109.043C229.516 108.79 229.311 108.585 229.059 108.585H226.963C226.71 108.585 226.506 108.79 226.506 109.043V111.256C226.506 111.509 226.71 111.713 226.963 111.713",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 111.713H223.977C224.23 111.713 224.434 111.509 224.434 111.256V109.043C224.434 108.79 224.23 108.585 223.977 108.585H221.881C221.629 108.585 221.424 108.79 221.424 109.043V111.256C221.424 111.509 221.629 111.713 221.881 111.713",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.8 111.713H218.895C219.148 111.713 219.353 111.509 219.353 111.256V109.043C219.353 108.79 219.148 108.585 218.895 108.585H216.8C216.547 108.585 216.343 108.79 216.343 109.043V111.256C216.343 111.509 216.547 111.713 216.8 111.713",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 111.713H213.813C214.066 111.713 214.271 111.509 214.271 111.256V109.043C214.271 108.79 214.066 108.585 213.813 108.585H211.718C211.466 108.585 211.261 108.79 211.261 109.043V111.256C211.261 111.509 211.466 111.713 211.718 111.713",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 104.504H229.059C229.311 104.504 229.516 104.3 229.516 104.047V101.833C229.516 101.58 229.311 101.376 229.059 101.376H226.963C226.71 101.376 226.506 101.58 226.506 101.833V104.047C226.506 104.3 226.71 104.504 226.963 104.504",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 104.504H223.977C224.23 104.504 224.434 104.3 224.434 104.047V101.833C224.434 101.58 224.23 101.376 223.977 101.376H221.881C221.629 101.376 221.424 101.58 221.424 101.833V104.047C221.424 104.3 221.629 104.504 221.881 104.504",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.8 104.504H218.895C219.148 104.504 219.353 104.3 219.353 104.047V101.833C219.353 101.58 219.148 101.376 218.895 101.376H216.8C216.547 101.376 216.343 101.58 216.343 101.833V104.047C216.343 104.3 216.547 104.504 216.8 104.504",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 104.504H213.813C214.066 104.504 214.271 104.3 214.271 104.047V101.833C214.271 101.58 214.066 101.376 213.813 101.376H211.718C211.466 101.376 211.261 101.58 211.261 101.833V104.047C211.261 104.3 211.466 104.504 211.718 104.504",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.963 97.4047H229.059C229.311 97.4047 229.516 97.2004 229.516 96.9477V94.7333C229.516 94.4814 229.311 94.2764 229.059 94.2764H226.963C226.71 94.2764 226.506 94.4814 226.506 94.7333V96.9477C226.506 97.2004 226.71 97.4047 226.963 97.4047",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.881 97.4047H223.977C224.23 97.4047 224.434 97.2004 224.434 96.9477V94.7333C224.434 94.4814 224.23 94.2764 223.977 94.2764H221.881C221.629 94.2764 221.424 94.4814 221.424 94.7333V96.9477C221.424 97.2004 221.629 97.4047 221.881 97.4047",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.343 97.4047H219.353V94.2764H216.343V97.4047Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.718 97.4047H213.813C214.066 97.4047 214.271 97.2004 214.271 96.9477V94.7333C214.271 94.4814 214.066 94.2764 213.813 94.2764H211.718C211.466 94.2764 211.261 94.4814 211.261 94.7333V96.9477C211.261 97.2004 211.466 97.4047 211.718 97.4047",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.48 89.9907V66.8642C229.48 66.6116 229.275 66.4072 229.023 66.4072H211.9C211.648 66.4072 211.444 66.6116 211.444 66.8642V89.9907C211.444 90.2426 211.648 90.4476 211.9 90.4476H229.023C229.275 90.4476 229.48 90.2426 229.48 89.9907Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.69 114.946V143.579C237.69 143.832 237.486 144.036 237.233 144.036H203.69C203.438 144.036 203.233 143.832 203.233 143.579V114.946C203.233 114.694 203.438 114.489 203.69 114.489H237.233C237.486 114.489 237.69 114.694 237.69 114.946Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.371 65.9498V56.4492C214.371 56.1965 214.571 55.9922 214.823 55.9922H226.085C226.337 55.9922 226.537 56.1965 226.537 56.4492V65.9498C226.537 66.2018 226.333 66.4068 226.081 66.4068H214.828C214.575 66.4068 214.371 66.2018 214.371 65.9498Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.656 49.205V55.5185C222.656 55.7712 222.451 55.9755 222.199 55.9755H218.724C218.472 55.9755 218.267 55.7712 218.267 55.5185V49.205C218.267 48.9524 218.472 48.748 218.724 48.748H222.199C222.451 48.748 222.656 48.9524 222.656 49.205Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.224 48.7636H219.699C219.447 48.7636 219.242 48.5593 219.242 48.3066V41.9931C219.242 41.7405 219.447 41.5361 219.699 41.5361H221.224C221.476 41.5361 221.681 41.7405 221.681 41.9931V48.3066C221.681 48.5593 221.476 48.7636 221.224 48.7636Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.757 41.5663H220.165C219.913 41.5663 219.709 41.362 219.709 41.1094V34.7958C219.709 34.5432 219.913 34.3389 220.165 34.3389H220.757C221.009 34.3389 221.214 34.5432 221.214 34.7958V41.1094C221.214 41.362 221.009 41.5663 220.757 41.5663Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.328 114.49H233.53",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.348 90.278H226.443C226.695 90.278 226.9 90.0736 226.9 89.821V80.2812C226.9 80.0286 226.695 79.8242 226.443 79.8242H224.348C224.095 79.8242 223.891 80.0286 223.891 80.2812V89.821C223.891 90.0736 224.095 90.278 224.348 90.278",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.266 90.278H221.361C221.614 90.278 221.818 90.0736 221.818 89.821V80.2812C221.818 80.0286 221.614 79.8242 221.361 79.8242H219.266C219.013 79.8242 218.809 80.0286 218.809 80.2812V89.821C218.809 90.0736 219.013 90.278 219.266 90.278",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.184 90.278H216.28C216.532 90.278 216.737 90.0736 216.737 89.821V80.2812C216.737 80.0286 216.532 79.8242 216.28 79.8242H214.184C213.932 79.8242 213.727 80.0286 213.727 80.2812V89.821C213.727 90.0736 213.932 90.278 214.184 90.278",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.257 77.7866H226.352C226.605 77.7866 226.809 77.5822 226.809 77.3296V75.1158C226.809 74.8632 226.605 74.6582 226.352 74.6582H224.257C224.004 74.6582 223.8 74.8632 223.8 75.1158V77.3296C223.8 77.5822 224.004 77.7866 224.257 77.7866",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.175 77.7866H221.27C221.523 77.7866 221.727 77.5822 221.727 77.3296V75.1158C221.727 74.8632 221.523 74.6582 221.27 74.6582H219.175C218.922 74.6582 218.718 74.8632 218.718 75.1158V77.3296C218.718 77.5822 218.922 77.7866 219.175 77.7866",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.093 77.7866H216.189C216.441 77.7866 216.646 77.5822 216.646 77.3296V75.1158C216.646 74.8632 216.441 74.6582 216.189 74.6582H214.093C213.841 74.6582 213.636 74.8632 213.636 75.1158V77.3296C213.636 77.5822 213.841 77.7866 214.093 77.7866",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.257 72.685H226.352C226.605 72.685 226.809 72.4807 226.809 72.228V70.0143C226.809 69.7616 226.605 69.5566 226.352 69.5566H224.257C224.004 69.5566 223.8 69.7616 223.8 70.0143V72.228C223.8 72.4807 224.004 72.685 224.257 72.685",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.175 72.685H221.27C221.523 72.685 221.727 72.4807 221.727 72.228V70.0143C221.727 69.7616 221.523 69.5566 221.27 69.5566H219.175C218.922 69.5566 218.718 69.7616 218.718 70.0143V72.228C218.718 72.4807 218.922 72.685 219.175 72.685",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.093 72.685H216.189C216.441 72.685 216.646 72.4807 216.646 72.228V70.0143C216.646 69.7616 216.441 69.5566 216.189 69.5566H214.093C213.841 69.5566 213.636 69.7616 213.636 70.0143V72.228C213.636 72.4807 213.841 72.685 214.093 72.685",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.907 62.9379H224.003C224.256 62.9379 224.46 62.7336 224.46 62.4809V60.2672C224.46 60.0146 224.256 59.8096 224.003 59.8096H221.907C221.655 59.8096 221.45 60.0146 221.45 60.2672V62.4809C221.45 62.7336 221.655 62.9379 221.907 62.9379",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.826 62.9379H218.921C219.174 62.9379 219.378 62.7336 219.378 62.4809V60.2672C219.378 60.0146 219.174 59.8096 218.921 59.8096H216.826C216.574 59.8096 216.369 60.0146 216.369 60.2672V62.4809C216.369 62.7336 216.574 62.9379 216.826 62.9379",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.36 114.032V90.9042C207.36 90.6516 207.564 90.4473 207.817 90.4473H233.106C233.358 90.4473 233.563 90.6516 233.563 90.9042V114.032C233.563 114.285 233.358 114.489 233.106 114.489H207.817C207.564 114.489 207.36 114.285 207.36 114.032Z",
    stroke: "#0A2A49",
    strokeWidth: 0.673066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.378 61.5435L168.768 51.5311C168.582 51.2862 168.213 51.2915 168.033 51.5408L159.473 63.4608C159.417 63.5385 159.387 63.6319 159.387 63.7272V66.9672V128.309C159.387 128.561 159.592 128.766 159.844 128.766H176.654H177.47C177.722 128.766 177.927 128.561 177.927 128.309V67.0827C177.927 64.8847 177.35 62.8217 176.378 61.5435",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 63.5806V137.453H175.142V70.3576C175.142 66.0156 174.211 61.8499 172.551 58.7646L168.394 51.0391L159.387 63.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 70.4609V72.6832C161.921 72.8653 164.557 72.9632 167.265 72.9632C170.981 72.9632 171.84 73.0997 175.204 72.7576V70.5354C171.84 70.8814 170.981 70.7456 167.265 70.7456C164.557 70.7456 161.921 70.647 159.387 70.4609",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 76.9971V79.2186C161.921 79.4014 164.557 79.4994 167.265 79.4994C170.981 79.4994 171.733 79.6848 175.095 79.342V77.1198C171.733 77.4658 170.981 77.2811 167.265 77.2811C164.557 77.2811 161.921 77.1825 159.387 76.9971",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 83.5315V85.7538C161.921 85.9359 164.557 86.0338 167.265 86.0338C170.981 86.0338 171.84 85.9888 175.204 85.6461V83.4238C171.84 83.7698 170.981 83.8155 167.265 83.8155C164.557 83.8155 161.921 83.7176 159.387 83.5315",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 90.0666V92.2888C161.921 92.4709 164.557 92.5689 167.265 92.5689C170.981 92.5689 171.84 92.5721 175.204 92.2294V90.0078C171.84 90.3538 170.981 90.3505 167.265 90.3505C164.557 90.3505 161.921 90.2526 159.387 90.0666",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 96.6016V98.8238C161.921 99.0059 164.557 99.1039 167.265 99.1039C170.981 99.1039 171.948 99.2194 175.311 98.8767V96.6551C171.948 97.0011 170.981 96.8855 167.265 96.8855C164.557 96.8855 161.921 96.7876 159.387 96.6016",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 103.137V105.359C161.921 105.541 164.557 105.639 167.265 105.639C170.981 105.639 171.948 105.804 175.311 105.461V103.239C171.948 103.585 170.981 103.421 167.265 103.421C164.557 103.421 161.921 103.323 159.387 103.137",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 109.672V111.894C161.921 112.076 164.557 112.174 167.265 112.174C170.981 112.174 171.733 112.279 175.095 111.937V109.715C171.733 110.061 170.981 109.957 167.265 109.957C164.557 109.957 161.921 109.858 159.387 109.672",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 116.207V118.429C161.921 118.611 164.557 118.709 167.265 118.709C170.981 118.709 171.84 118.863 175.204 118.521V116.298C171.84 116.644 170.981 116.491 167.265 116.491C164.557 116.491 161.921 116.392 159.387 116.207",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.387 122.742V124.964C161.921 125.147 164.557 125.244 167.265 125.244C170.981 125.244 171.948 125.339 175.311 124.997V122.775C171.948 123.121 170.981 123.026 167.265 123.026C164.557 123.026 161.921 122.928 159.387 122.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.236 63.728V137.453H173.99V70.3581C173.99 66.0161 173.059 61.8504 171.399 58.7651L167.59 51.6839C167.429 51.3862 167.013 51.3595 166.816 51.6337L158.321 63.4616C158.266 63.5393 158.236 63.6326 158.236 63.728Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.927 143.681H190.122C190.375 143.681 190.579 143.476 190.579 143.224V78.456C190.579 78.2034 190.375 77.999 190.122 77.999H174.927C174.675 77.999 174.47 78.2034 174.47 78.456V143.224C174.47 143.476 174.675 143.681 174.927 143.681",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 28,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.81201 217.422H241.063V28.2725H-1.81201V217.422Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.505 143.681H187.613V77.999H171.505V143.681Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.853 143.681H187.613V77.999H169.853V143.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.67 143.879H185.778V78.1973H169.67V143.879Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 115.137H183.795C184.047 115.137 184.252 114.933 184.252 114.68V112.618C184.252 112.366 184.047 112.161 183.795 112.161H182.038C181.785 112.161 181.581 112.366 181.581 112.618V114.68C181.581 114.933 181.785 115.137 182.038 115.137",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 115.137H179.663C179.916 115.137 180.121 114.933 180.121 114.68V112.618C180.121 112.366 179.916 112.161 179.663 112.161H177.907C177.655 112.161 177.45 112.366 177.45 112.618V114.68C177.45 114.933 177.655 115.137 177.907 115.137",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 115.137H175.532C175.785 115.137 175.99 114.933 175.99 114.68V112.618C175.99 112.366 175.785 112.161 175.532 112.161H173.776C173.524 112.161 173.319 112.366 173.319 112.618V114.68C173.319 114.933 173.524 115.137 173.776 115.137",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 109.216H183.795C184.047 109.216 184.252 109.012 184.252 108.759V106.697C184.252 106.445 184.047 106.24 183.795 106.24H182.038C181.785 106.24 181.581 106.445 181.581 106.697V108.759C181.581 109.012 181.785 109.216 182.038 109.216",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 109.216H179.663C179.916 109.216 180.121 109.012 180.121 108.759V106.697C180.121 106.445 179.916 106.24 179.663 106.24H177.907C177.655 106.24 177.45 106.445 177.45 106.697V108.759C177.45 109.012 177.655 109.216 177.907 109.216",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 109.216H175.532C175.785 109.216 175.99 109.012 175.99 108.759V106.697C175.99 106.445 175.785 106.24 175.532 106.24H173.776C173.524 106.24 173.319 106.445 173.319 106.697V108.759C173.319 109.012 173.524 109.216 173.776 109.216",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 103.296H183.795C184.047 103.296 184.252 103.091 184.252 102.839V100.776C184.252 100.524 184.047 100.319 183.795 100.319H182.038C181.785 100.319 181.581 100.524 181.581 100.776V102.839C181.581 103.091 181.785 103.296 182.038 103.296",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 103.296H179.663C179.916 103.296 180.121 103.091 180.121 102.839V100.776C180.121 100.524 179.916 100.319 179.663 100.319H177.907C177.655 100.319 177.45 100.524 177.45 100.776V102.839C177.45 103.091 177.655 103.296 177.907 103.296",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 103.296H175.532C175.785 103.296 175.99 103.091 175.99 102.839V100.776C175.99 100.524 175.785 100.319 175.532 100.319H173.776C173.524 100.319 173.319 100.524 173.319 100.776V102.839C173.319 103.091 173.524 103.296 173.776 103.296",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 132.658H183.795C184.047 132.658 184.252 132.454 184.252 132.201V130.139C184.252 129.887 184.047 129.682 183.795 129.682H182.038C181.785 129.682 181.581 129.887 181.581 130.139V132.201C181.581 132.454 181.785 132.658 182.038 132.658",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 132.658H179.663C179.916 132.658 180.121 132.454 180.121 132.201V130.139C180.121 129.887 179.916 129.682 179.663 129.682H177.907C177.655 129.682 177.45 129.887 177.45 130.139V132.201C177.45 132.454 177.655 132.658 177.907 132.658",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 132.658H175.532C175.785 132.658 175.99 132.454 175.99 132.201V130.139C175.99 129.887 175.785 129.682 175.532 129.682H173.776C173.524 129.682 173.319 129.887 173.319 130.139V132.201C173.319 132.454 173.524 132.658 173.776 132.658",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 126.737H183.795C184.047 126.737 184.252 126.533 184.252 126.28V124.218C184.252 123.965 184.047 123.761 183.795 123.761H182.038C181.785 123.761 181.581 123.965 181.581 124.218V126.28C181.581 126.533 181.785 126.737 182.038 126.737",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.45 126.737H180.121V123.761H177.45V126.737Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 126.737H175.532C175.785 126.737 175.99 126.533 175.99 126.28V124.218C175.99 123.965 175.785 123.761 175.532 123.761H173.776C173.524 123.761 173.319 123.965 173.319 124.218V126.28C173.319 126.533 173.524 126.737 173.776 126.737",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 120.816H183.795C184.047 120.816 184.252 120.612 184.252 120.359V118.297C184.252 118.044 184.047 117.84 183.795 117.84H182.038C181.785 117.84 181.581 118.044 181.581 118.297V120.359C181.581 120.612 181.785 120.816 182.038 120.816",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 120.816H179.663C179.916 120.816 180.121 120.612 180.121 120.359V118.297C180.121 118.044 179.916 117.84 179.663 117.84H177.907C177.655 117.84 177.45 118.044 177.45 118.297V120.359C177.45 120.612 177.655 120.816 177.907 120.816",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 120.816H175.532C175.785 120.816 175.99 120.612 175.99 120.359V118.297C175.99 118.044 175.785 117.84 175.532 117.84H173.776C173.524 117.84 173.319 118.044 173.319 118.297V120.359C173.319 120.612 173.524 120.816 173.776 120.816",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 97.3737H183.795C184.047 97.3737 184.252 97.1694 184.252 96.9167V94.8544C184.252 94.6024 184.047 94.3975 183.795 94.3975H182.038C181.785 94.3975 181.581 94.6024 181.581 94.8544V96.9167C181.581 97.1694 181.785 97.3737 182.038 97.3737",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 97.3737H179.663C179.916 97.3737 180.121 97.1694 180.121 96.9167V94.8544C180.121 94.6024 179.916 94.3975 179.663 94.3975H177.907C177.655 94.3975 177.45 94.6024 177.45 94.8544V96.9167C177.45 97.1694 177.655 97.3737 177.907 97.3737",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 97.3737H175.532C175.785 97.3737 175.99 97.1694 175.99 96.9167V94.8544C175.99 94.6024 175.785 94.3975 175.532 94.3975H173.776C173.524 94.3975 173.319 94.6024 173.319 94.8544V96.9167C173.319 97.1694 173.524 97.3737 173.776 97.3737",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.038 91.4528H183.795C184.047 91.4528 184.252 91.2485 184.252 90.9958V88.9335C184.252 88.6816 184.047 88.4766 183.795 88.4766H182.038C181.785 88.4766 181.581 88.6816 181.581 88.9335V90.9958C181.581 91.2485 181.785 91.4528 182.038 91.4528",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 91.4528H179.663C179.916 91.4528 180.121 91.2485 180.121 90.9958V88.9335C180.121 88.6816 179.916 88.4766 179.663 88.4766H177.907C177.655 88.4766 177.45 88.6816 177.45 88.9335V90.9958C177.45 91.2485 177.655 91.4528 177.907 91.4528",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 91.4528H175.532C175.785 91.4528 175.99 91.2485 175.99 90.9958V88.9335C175.99 88.6816 175.785 88.4766 175.532 88.4766H173.776C173.524 88.4766 173.319 88.6816 173.319 88.9335V90.9958C173.319 91.2485 173.524 91.4528 173.776 91.4528",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.581 85.5319H184.252V82.5557H181.581V85.5319Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.907 85.5319H179.663C179.916 85.5319 180.121 85.3276 180.121 85.0749V83.0126C180.121 82.7607 179.916 82.5557 179.663 82.5557H177.907C177.655 82.5557 177.45 82.7607 177.45 83.0126V85.0749C177.45 85.3276 177.655 85.5319 177.907 85.5319",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.776 85.5319H175.532C175.785 85.5319 175.99 85.3276 175.99 85.0749V83.0126C175.99 82.7607 175.785 82.5557 175.532 82.5557H173.776C173.524 82.5557 173.319 82.7607 173.319 83.0126V85.0749C173.319 85.3276 173.524 85.5319 173.776 85.5319",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.969 138.033H159.164C159.416 138.033 159.621 137.828 159.621 137.576V84.1796C159.621 83.927 159.416 83.7227 159.164 83.7227H143.969C143.716 83.7227 143.512 83.927 143.512 84.1796V137.576C143.512 137.828 143.716 138.033 143.969 138.033",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 28,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.81201 217.422H241.063V28.2725H-1.81201V217.422Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.546 138.033H156.656V83.7227H140.546V138.033Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.546 138.033H156.656V83.7227H140.546V138.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.277 138.321H154.471C154.724 138.321 154.929 138.117 154.929 137.864V84.4677C154.929 84.2151 154.724 84.0107 154.471 84.0107H139.277C139.024 84.0107 138.82 84.2151 138.82 84.4677V137.864C138.82 138.117 139.024 138.321 139.277 138.321Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.623 120.861H153.294V117.885H150.623V120.861Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 120.861H148.705C148.958 120.861 149.163 120.657 149.163 120.404V118.342C149.163 118.09 148.958 117.885 148.705 117.885H146.949C146.697 117.885 146.492 118.09 146.492 118.342V120.404C146.492 120.657 146.697 120.861 146.949 120.861",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 120.861H144.575C144.827 120.861 145.032 120.657 145.032 120.404V118.342C145.032 118.09 144.827 117.885 144.575 117.885H142.818C142.566 117.885 142.361 118.09 142.361 118.342V120.404C142.361 120.657 142.566 120.861 142.818 120.861",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 114.94H152.836C153.089 114.94 153.294 114.736 153.294 114.483V112.421C153.294 112.169 153.089 111.964 152.836 111.964H151.08C150.827 111.964 150.623 112.169 150.623 112.421V114.483C150.623 114.736 150.827 114.94 151.08 114.94",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 114.94H148.705C148.958 114.94 149.163 114.736 149.163 114.483V112.421C149.163 112.169 148.958 111.964 148.705 111.964H146.949C146.697 111.964 146.492 112.169 146.492 112.421V114.483C146.492 114.736 146.697 114.94 146.949 114.94",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 114.94H144.575C144.827 114.94 145.032 114.736 145.032 114.483V112.421C145.032 112.169 144.827 111.964 144.575 111.964H142.818C142.566 111.964 142.361 112.169 142.361 112.421V114.483C142.361 114.736 142.566 114.94 142.818 114.94",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 132.81H152.836C153.089 132.81 153.294 132.606 153.294 132.353V130.291C153.294 130.038 153.089 129.834 152.836 129.834H151.08C150.827 129.834 150.623 130.038 150.623 130.291V132.353C150.623 132.606 150.827 132.81 151.08 132.81",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 132.81H148.705C148.958 132.81 149.163 132.606 149.163 132.353V130.291C149.163 130.038 148.958 129.834 148.705 129.834H146.949C146.697 129.834 146.492 130.038 146.492 130.291V132.353C146.492 132.606 146.697 132.81 146.949 132.81",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 132.81H144.575C144.827 132.81 145.032 132.606 145.032 132.353V130.291C145.032 130.038 144.827 129.834 144.575 129.834H142.818C142.566 129.834 142.361 130.038 142.361 130.291V132.353C142.361 132.606 142.566 132.81 142.818 132.81",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 126.889H152.836C153.089 126.889 153.294 126.685 153.294 126.432V124.37C153.294 124.117 153.089 123.913 152.836 123.913H151.08C150.827 123.913 150.623 124.117 150.623 124.37V126.432C150.623 126.685 150.827 126.889 151.08 126.889",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 126.889H148.705C148.958 126.889 149.163 126.685 149.163 126.432V124.37C149.163 124.117 148.958 123.913 148.705 123.913H146.949C146.697 123.913 146.492 124.117 146.492 124.37V126.432C146.492 126.685 146.697 126.889 146.949 126.889",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.361 126.889H145.031V123.913H142.361V126.889Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 109.019H152.836C153.089 109.019 153.294 108.815 153.294 108.562V106.5C153.294 106.248 153.089 106.043 152.836 106.043H151.08C150.827 106.043 150.623 106.248 150.623 106.5V108.562C150.623 108.815 150.827 109.019 151.08 109.019",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 109.019H148.705C148.958 109.019 149.163 108.815 149.163 108.562V106.5C149.163 106.248 148.958 106.043 148.705 106.043H146.949C146.697 106.043 146.492 106.248 146.492 106.5V108.562C146.492 108.815 146.697 109.019 146.949 109.019",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 109.019H144.575C144.827 109.019 145.032 108.815 145.032 108.562V106.5C145.032 106.248 144.827 106.043 144.575 106.043H142.818C142.566 106.043 142.361 106.248 142.361 106.5V108.562C142.361 108.815 142.566 109.019 142.818 109.019",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 103.098H152.836C153.089 103.098 153.294 102.894 153.294 102.641V100.579C153.294 100.327 153.089 100.122 152.836 100.122H151.08C150.827 100.122 150.623 100.327 150.623 100.579V102.641C150.623 102.894 150.827 103.098 151.08 103.098",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 103.098H148.705C148.958 103.098 149.163 102.894 149.163 102.641V100.579C149.163 100.327 148.958 100.122 148.705 100.122H146.949C146.697 100.122 146.492 100.327 146.492 100.579V102.641C146.492 102.894 146.697 103.098 146.949 103.098",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 103.098H144.575C144.827 103.098 145.032 102.894 145.032 102.641V100.579C145.032 100.327 144.827 100.122 144.575 100.122H142.818C142.566 100.122 142.361 100.327 142.361 100.579V102.641C142.361 102.894 142.566 103.098 142.818 103.098",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 97.1764H152.836C153.089 97.1764 153.294 96.9721 153.294 96.7195V94.6572C153.294 94.4052 153.089 94.2002 152.836 94.2002H151.08C150.827 94.2002 150.623 94.4052 150.623 94.6572V96.7195C150.623 96.9721 150.827 97.1764 151.08 97.1764",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 97.1764H148.705C148.958 97.1764 149.163 96.9721 149.163 96.7195V94.6572C149.163 94.4052 148.958 94.2002 148.705 94.2002H146.949C146.697 94.2002 146.492 94.4052 146.492 94.6572V96.7195C146.492 96.9721 146.697 97.1764 146.949 97.1764",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 97.1764H144.575C144.827 97.1764 145.032 96.9721 145.032 96.7195V94.6572C145.032 94.4052 144.827 94.2002 144.575 94.2002H142.818C142.566 94.2002 142.361 94.4052 142.361 94.6572V96.7195C142.361 96.9721 142.566 97.1764 142.818 97.1764",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.08 91.2555H152.836C153.089 91.2555 153.294 91.0512 153.294 90.7986V88.7363C153.294 88.4843 153.089 88.2793 152.836 88.2793H151.08C150.827 88.2793 150.623 88.4843 150.623 88.7363V90.7986C150.623 91.0512 150.827 91.2555 151.08 91.2555",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.949 91.2555H148.705C148.958 91.2555 149.163 91.0512 149.163 90.7986V88.7363C149.163 88.4843 148.958 88.2793 148.705 88.2793H146.949C146.697 88.2793 146.492 88.4843 146.492 88.7363V90.7986C146.492 91.0512 146.697 91.2555 146.949 91.2555",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.818 91.2555H144.575C144.827 91.2555 145.032 91.0512 145.032 90.7986V88.7363C145.032 88.4843 144.827 88.2793 144.575 88.2793H142.818C142.566 88.2793 142.361 88.4843 142.361 88.7363V90.7986C142.361 91.0512 142.566 91.2555 142.818 91.2555",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6673 127.43H108.829C109.081 127.43 109.284 127.226 109.284 126.975V58.7792C109.284 58.5279 109.081 58.3242 108.829 58.3242H92.6673C92.416 58.3242 92.2117 58.5279 92.2117 58.7792V126.975C92.2117 127.226 92.416 127.43 92.6673 127.43",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 20,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12891 209.893H248.004V20.7432H5.12891V209.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3425 127.43H106.415V58.2324H89.3425V127.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 97.1789H101.668C101.92 97.1789 102.125 96.9745 102.125 96.7219V94.482C102.125 94.2294 101.92 94.0244 101.668 94.0244H99.7517C99.499 94.0244 99.2947 94.2294 99.2947 94.482V96.7219C99.2947 96.9745 99.499 97.1789 99.7517 97.1789",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 97.1789H97.7463V94.0244H94.9163V97.1789Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 97.1789H93.3686V94.0244H90.5386V97.1789Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 90.9035H101.668C101.92 90.9035 102.125 90.6992 102.125 90.4465V88.2067C102.125 87.954 101.92 87.749 101.668 87.749H99.7517C99.499 87.749 99.2947 87.954 99.2947 88.2067V90.4465C99.2947 90.6992 99.499 90.9035 99.7517 90.9035",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 90.9035H97.7463V87.749H94.9163V90.9035Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 90.9035H93.3686V87.749H90.5386V90.9035Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 84.6281H101.668C101.92 84.6281 102.125 84.4238 102.125 84.1711V81.9313C102.125 81.6786 101.92 81.4736 101.668 81.4736H99.7517C99.499 81.4736 99.2947 81.6786 99.2947 81.9313V84.1711C99.2947 84.4238 99.499 84.6281 99.7517 84.6281",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 84.6281H97.7463V81.4736H94.9163V84.6281Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 84.6281H93.3686V81.4736H90.5386V84.6281Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 115.748H101.668C101.92 115.748 102.125 115.543 102.125 115.291V113.051C102.125 112.798 101.92 112.594 101.668 112.594H99.7517C99.499 112.594 99.2947 112.798 99.2947 113.051V115.291C99.2947 115.543 99.499 115.748 99.7517 115.748",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 115.748H97.7463V112.594H94.9163V115.748Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 115.748H93.3686V112.594H90.5386V115.748Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 109.472H101.668C101.92 109.472 102.125 109.268 102.125 109.015V106.775C102.125 106.523 101.92 106.318 101.668 106.318H99.7517C99.499 106.318 99.2947 106.523 99.2947 106.775V109.015C99.2947 109.268 99.499 109.472 99.7517 109.472",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 109.472H97.7463V106.318H94.9163V109.472Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 109.472H93.3686V106.318H90.5386V109.472Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 103.197H101.668C101.92 103.197 102.125 102.992 102.125 102.74V100.5C102.125 100.247 101.92 100.043 101.668 100.043H99.7517C99.499 100.043 99.2947 100.247 99.2947 100.5V102.74C99.2947 102.992 99.499 103.197 99.7517 103.197",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 103.197H97.7463V100.043H94.9163V103.197Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 103.197H93.3686V100.043H90.5386V103.197Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 78.3537H101.668C101.92 78.3537 102.125 78.1494 102.125 77.8967V75.6569C102.125 75.4042 101.92 75.1992 101.668 75.1992H99.7517C99.499 75.1992 99.2947 75.4042 99.2947 75.6569V77.8967C99.2947 78.1494 99.499 78.3537 99.7517 78.3537",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 78.3537H97.7463V75.1992H94.9163V78.3537Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5386 78.3537H93.3686V75.1992H90.5386V78.3537Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 72.0783H101.668C101.92 72.0783 102.125 71.874 102.125 71.6213V69.3815C102.125 69.1288 101.92 68.9238 101.668 68.9238H99.7517C99.499 68.9238 99.2947 69.1288 99.2947 69.3815V71.6213C99.2947 71.874 99.499 72.0783 99.7517 72.0783",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 72.0783H97.7463V68.9238H94.9163V72.0783Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9956 72.0783H92.9123C93.1643 72.0783 93.3686 71.874 93.3686 71.6213V69.3815C93.3686 69.1288 93.1643 68.9238 92.9123 68.9238H90.9956C90.7429 68.9238 90.5386 69.1288 90.5386 69.3815V71.6213C90.5386 71.874 90.7429 72.0783 90.9956 72.0783",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7517 65.8029H101.668C101.92 65.8029 102.125 65.5986 102.125 65.3459V63.1061C102.125 62.8534 101.92 62.6484 101.668 62.6484H99.7517C99.499 62.6484 99.2947 62.8534 99.2947 63.1061V65.3459C99.2947 65.5986 99.499 65.8029 99.7517 65.8029",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9163 65.8029H97.7463V62.6484H94.9163V65.8029Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9956 65.8029H92.9123C93.1643 65.8029 93.3686 65.5986 93.3686 65.3459V63.1061C93.3686 62.8534 93.1643 62.6484 92.9123 62.6484H90.9956C90.7429 62.6484 90.5386 62.8534 90.5386 63.1061V65.3459C90.5386 65.5986 90.7429 65.8029 90.9956 65.8029",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0725 128.006H104.231C104.483 128.006 104.688 127.802 104.688 127.549V58.8525C104.688 58.6005 104.483 58.3955 104.231 58.3955H88.0725C87.8205 58.3955 87.6155 58.6005 87.6155 58.8525V127.549C87.6155 127.802 87.8205 128.006 88.0725 128.006Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2824 129.653H94.4406C94.6932 129.653 94.8982 129.449 94.8982 129.196V72.5517C94.8982 72.2991 94.6932 72.0947 94.4406 72.0947H78.2824C78.0298 72.0947 77.8254 72.2991 77.8254 72.5517V129.196C77.8254 129.449 78.0298 129.653 78.2824 129.653",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 20,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12891 209.893H248.004V20.7432H5.12891V209.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2898 129.654H92.3619V72.0957H75.2898V129.654Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2898 129.654H92.3619V72.0957H75.2898V129.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3078 129.474H90.466C90.7186 129.474 90.9236 129.269 90.9236 129.017V72.372C90.9236 72.1194 90.7186 71.915 90.466 71.915H74.3078C74.0552 71.915 73.8508 72.1194 73.8508 72.372V129.017C73.8508 129.269 74.0552 129.474 74.3078 129.474Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0156 111.455H88.8456V108.758C88.8456 108.505 88.6413 108.301 88.3887 108.301H86.0156V111.455Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 111.455H84.0107C84.2634 111.455 84.4677 111.25 84.4677 110.998V108.758C84.4677 108.505 84.2634 108.301 84.0107 108.301H82.0947C81.842 108.301 81.6377 108.505 81.6377 108.758V110.998C81.6377 111.25 81.842 111.455 82.0947 111.455",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2593 111.455H80.0893V108.301H77.2593V111.455Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 105.179H88.3893C88.6413 105.179 88.8456 104.975 88.8456 104.722V102.482C88.8456 102.23 88.6413 102.025 88.3893 102.025H86.4726C86.22 102.025 86.0156 102.23 86.0156 102.482V104.722C86.0156 104.975 86.22 105.179 86.4726 105.179",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 105.179H84.0107C84.2634 105.179 84.4677 104.975 84.4677 104.722V102.482C84.4677 102.23 84.2634 102.025 84.0107 102.025H82.0947C81.842 102.025 81.6377 102.23 81.6377 102.482V104.722C81.6377 104.975 81.842 105.179 82.0947 105.179",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 105.179H79.633C79.885 105.179 80.0899 104.975 80.0899 104.722V102.482C80.0899 102.23 79.885 102.025 79.633 102.025H77.7163C77.4643 102.025 77.2593 102.23 77.2593 102.482V104.722C77.2593 104.975 77.4643 105.179 77.7163 105.179",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 124.119H88.3893C88.6413 124.119 88.8456 123.914 88.8456 123.662V121.422C88.8456 121.169 88.6413 120.965 88.3893 120.965H86.4726C86.22 120.965 86.0156 121.169 86.0156 121.422V123.662C86.0156 123.914 86.22 124.119 86.4726 124.119",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 124.119H84.0107C84.2634 124.119 84.4677 123.914 84.4677 123.662V121.422C84.4677 121.169 84.2634 120.965 84.0107 120.965H82.0947C81.842 120.965 81.6377 121.169 81.6377 121.422V123.662C81.6377 123.914 81.842 124.119 82.0947 124.119",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 124.119H79.633C79.885 124.119 80.0899 123.914 80.0899 123.662V121.422C80.0899 121.169 79.885 120.965 79.633 120.965H77.7163C77.4643 120.965 77.2593 121.169 77.2593 121.422V123.662C77.2593 123.914 77.4643 124.119 77.7163 124.119",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 117.843H88.3893C88.6413 117.843 88.8456 117.639 88.8456 117.386V115.146C88.8456 114.893 88.6413 114.688 88.3893 114.688H86.4726C86.22 114.688 86.0156 114.893 86.0156 115.146V117.386C86.0156 117.639 86.22 117.843 86.4726 117.843",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 117.843H84.0107C84.2634 117.843 84.4677 117.639 84.4677 117.386V115.146C84.4677 114.893 84.2634 114.688 84.0107 114.688H82.0947C81.842 114.688 81.6377 114.893 81.6377 115.146V117.386C81.6377 117.639 81.842 117.843 82.0947 117.843",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 117.843H79.633C79.885 117.843 80.0899 117.639 80.0899 117.386V115.146C80.0899 114.893 79.885 114.688 79.633 114.688H77.7163C77.4643 114.688 77.2593 114.893 77.2593 115.146V117.386C77.2593 117.639 77.4643 117.843 77.7163 117.843",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0156 98.9038H88.8456V95.75H86.0156V98.9038Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 98.9038H84.0107C84.2634 98.9038 84.4677 98.6995 84.4677 98.4468V96.207C84.4677 95.9543 84.2634 95.75 84.0107 95.75H82.0947C81.842 95.75 81.6377 95.9543 81.6377 96.207V98.4468C81.6377 98.6995 81.842 98.9038 82.0947 98.9038",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 98.9038H79.633C79.885 98.9038 80.0899 98.6995 80.0899 98.4468V96.207C80.0899 95.9543 79.885 95.75 79.633 95.75H77.7163C77.4643 95.75 77.2593 95.9543 77.2593 96.207V98.4468C77.2593 98.6995 77.4643 98.9038 77.7163 98.9038",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 92.6284H88.3893C88.6413 92.6284 88.8456 92.4241 88.8456 92.1714V89.9316C88.8456 89.6789 88.6413 89.4746 88.3893 89.4746H86.4726C86.22 89.4746 86.0156 89.6789 86.0156 89.9316V92.1714C86.0156 92.4241 86.22 92.6284 86.4726 92.6284",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 92.6284H84.0107C84.2634 92.6284 84.4677 92.4241 84.4677 92.1714V89.9316C84.4677 89.6789 84.2634 89.4746 84.0107 89.4746H82.0947C81.842 89.4746 81.6377 89.6789 81.6377 89.9316V92.1714C81.6377 92.4241 81.842 92.6284 82.0947 92.6284",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 92.6284H79.633C79.885 92.6284 80.0899 92.4241 80.0899 92.1714V89.9316C80.0899 89.6789 79.885 89.4746 79.633 89.4746H77.7163C77.4643 89.4746 77.2593 89.6789 77.2593 89.9316V92.1714C77.2593 92.4241 77.4643 92.6284 77.7163 92.6284",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 86.353H88.3893C88.6413 86.353 88.8456 86.1487 88.8456 85.8961V83.6562C88.8456 83.4036 88.6413 83.1992 88.3893 83.1992H86.4726C86.22 83.1992 86.0156 83.4036 86.0156 83.6562V85.8961C86.0156 86.1487 86.22 86.353 86.4726 86.353",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 86.353H84.0107C84.2634 86.353 84.4677 86.1487 84.4677 85.8961V83.6562C84.4677 83.4036 84.2634 83.1992 84.0107 83.1992H82.0947C81.842 83.1992 81.6377 83.4036 81.6377 83.6562V85.8961C81.6377 86.1487 81.842 86.353 82.0947 86.353",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7163 86.353H79.633C79.885 86.353 80.0899 86.1487 80.0899 85.8961V83.6562C80.0899 83.4036 79.885 83.1992 79.633 83.1992H77.7163C77.4643 83.1992 77.2593 83.4036 77.2593 83.6562V85.8961C77.2593 86.1487 77.4643 86.353 77.7163 86.353",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4726 80.0786H88.3893C88.6413 80.0786 88.8456 79.8743 88.8456 79.6216V77.3818C88.8456 77.1291 88.6413 76.9248 88.3893 76.9248H86.4726C86.22 76.9248 86.0156 77.1291 86.0156 77.3818V79.6216C86.0156 79.8743 86.22 80.0786 86.4726 80.0786",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0947 80.0786H84.0107C84.2634 80.0786 84.4677 79.8743 84.4677 79.6216V77.3818C84.4677 77.1291 84.2634 76.9248 84.0107 76.9248H82.0947C81.842 76.9248 81.6377 77.1291 81.6377 77.3818V79.6216C81.6377 79.8743 81.842 80.0786 82.0947 80.0786",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2595 80.0786H79.6326C79.8852 80.0786 80.0895 79.8743 80.0895 79.6216V76.9248H77.2595V80.0786Z",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3454 71.8916H65.5042C65.7562 71.8916 65.9612 71.6872 65.9612 71.4346V44.6562C65.9612 44.4042 65.7562 44.1992 65.5042 44.1992H49.3454C49.0928 44.1992 48.8884 44.4042 48.8884 44.6562V71.4346C48.8884 71.6872 49.0928 71.8916 49.3454 71.8916",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3535 99.4622H69.5116C69.7643 99.4622 69.9693 99.2578 69.9693 99.0052V72.2268C69.9693 71.9748 69.7643 71.7705 69.5116 71.7705H53.3535C53.1008 71.7705 52.8965 71.9748 52.8965 72.2268V99.0052C52.8965 99.2578 53.1008 99.4622 53.3535 99.4622",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4748 133.469H75.5363C75.8157 133.469 76.0416 133.243 76.0416 132.964V100.089C76.0416 99.8095 75.8157 99.583 75.5363 99.583H59.4748C59.1954 99.583 58.9695 99.8095 58.9695 100.089V132.964C58.9695 133.243 59.1954 133.469 59.4748 133.469",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.667 99.5481V71.7448H63.6586V44.1406H59.6385V32.1396H56.7602V44.1406H50.7163V32.1396H47.838V44.1406H42.8895V71.8434H38.8883V99.5481H32.644V133.596H73.4967V99.5481H67.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2426 133.332H67.7873C68.04 133.332 68.2443 133.128 68.2443 132.875V120.083C68.2443 119.831 68.04 119.626 67.7873 119.626H65.2426C64.99 119.626 64.7856 119.831 64.7856 120.083V132.875C64.7856 133.128 64.99 133.332 65.2426 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4018 133.332H61.9465C62.1992 133.332 62.4035 133.128 62.4035 132.875V120.083C62.4035 119.831 62.1992 119.626 61.9465 119.626H59.4018C59.1492 119.626 58.9448 119.831 58.9448 120.083V132.875C58.9448 133.128 59.1492 133.332 59.4018 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 133.332H56.1057C56.3584 133.332 56.5627 133.128 56.5627 132.875V120.083C56.5627 119.831 56.3584 119.626 56.1057 119.626H53.561C53.3083 119.626 53.104 119.831 53.104 120.083V132.875C53.104 133.128 53.3083 133.332 53.561 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 133.332H50.2651C50.5178 133.332 50.7228 133.128 50.7228 132.875V120.083C50.7228 119.831 50.5178 119.626 50.2651 119.626H47.7204C47.4684 119.626 47.2634 119.831 47.2634 120.083V132.875C47.2634 133.128 47.4684 133.332 47.7204 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0343 133.332H44.2702C44.6078 133.332 44.8819 133.059 44.8819 132.72V120.238C44.8819 119.9 44.6078 119.626 44.2702 119.626H42.0343C41.6968 119.626 41.4226 119.9 41.4226 120.238V132.72C41.4226 133.059 41.6968 133.332 42.0343 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0393 133.332H38.584C38.8366 133.332 39.041 133.128 39.041 132.875V120.083C39.041 119.831 38.8366 119.626 38.584 119.626H36.0393C35.7866 119.626 35.5823 119.831 35.5823 120.083V132.875C35.5823 133.128 35.7866 133.332 36.0393 133.332",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2426 114.788H67.7873C68.04 114.788 68.2443 114.584 68.2443 114.332V111.65C68.2443 111.398 68.04 111.193 67.7873 111.193H65.2426C64.99 111.193 64.7856 111.398 64.7856 111.65V114.332C64.7856 114.584 64.99 114.788 65.2426 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4018 114.788H61.9465C62.1992 114.788 62.4035 114.584 62.4035 114.332V111.65C62.4035 111.398 62.1992 111.193 61.9465 111.193H59.4018C59.1492 111.193 58.9448 111.398 58.9448 111.65V114.332C58.9448 114.584 59.1492 114.788 59.4018 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 114.788H56.1057C56.3584 114.788 56.5627 114.584 56.5627 114.332V111.65C56.5627 111.398 56.3584 111.193 56.1057 111.193H53.561C53.3083 111.193 53.104 111.398 53.104 111.65V114.332C53.104 114.584 53.3083 114.788 53.561 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 114.788H50.2651C50.5178 114.788 50.7228 114.584 50.7228 114.332V111.65C50.7228 111.398 50.5178 111.193 50.2651 111.193H47.7204C47.4684 111.193 47.2634 111.398 47.2634 111.65V114.332C47.2634 114.584 47.4684 114.788 47.7204 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8801 114.788H44.0468C44.5077 114.788 44.8818 114.414 44.8818 113.954V112.028C44.8818 111.567 44.5077 111.193 44.0468 111.193H42.2581C41.7972 111.193 41.4231 111.567 41.4231 112.028V114.332C41.4231 114.584 41.6274 114.788 41.8801 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0393 114.788H38.4208C38.7635 114.788 39.041 114.511 39.041 114.168V111.814C39.041 111.471 38.7635 111.193 38.4208 111.193H36.2025C35.8597 111.193 35.5823 111.471 35.5823 111.814V114.332C35.5823 114.584 35.7866 114.788 36.0393 114.788",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2426 107.565H67.7873C68.04 107.565 68.2443 107.361 68.2443 107.108V104.426C68.2443 104.174 68.04 103.97 67.7873 103.97H65.2426C64.99 103.97 64.7856 104.174 64.7856 104.426V107.108C64.7856 107.361 64.99 107.565 65.2426 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4018 107.565H61.9465C62.1992 107.565 62.4035 107.361 62.4035 107.108V104.426C62.4035 104.174 62.1992 103.97 61.9465 103.97H59.4018C59.1492 103.97 58.9448 104.174 58.9448 104.426V107.108C58.9448 107.361 59.1492 107.565 59.4018 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 107.565H56.1057C56.3584 107.565 56.5627 107.361 56.5627 107.108V104.426C56.5627 104.174 56.3584 103.97 56.1057 103.97H53.561C53.3083 103.97 53.104 104.174 53.104 104.426V107.108C53.104 107.361 53.3083 107.565 53.561 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 107.565H50.2651C50.5178 107.565 50.7228 107.361 50.7228 107.108V104.426C50.7228 104.174 50.5178 103.97 50.2651 103.97H47.7204C47.4684 103.97 47.2634 104.174 47.2634 104.426V107.108C47.2634 107.361 47.4684 107.565 47.7204 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8801 107.565H44.4248C44.6774 107.565 44.8818 107.361 44.8818 107.108V104.426C44.8818 104.174 44.6774 103.97 44.4248 103.97H41.8801C41.6274 103.97 41.4231 104.174 41.4231 104.426V107.108C41.4231 107.361 41.6274 107.565 41.8801 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0393 107.565H38.584C38.8366 107.565 39.041 107.361 39.041 107.108V104.426C39.041 104.174 38.8366 103.97 38.584 103.97H36.0393C35.7866 103.97 35.5823 104.174 35.5823 104.426V107.108C35.5823 107.361 35.7866 107.565 36.0393 107.565",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4018 96.4457H61.9465C62.1992 96.4457 62.4035 96.2414 62.4035 95.9887V93.3076C62.4035 93.0549 62.1992 92.8506 61.9465 92.8506H59.4018C59.1492 92.8506 58.9448 93.0549 58.9448 93.3076V95.9887C58.9448 96.2414 59.1492 96.4457 59.4018 96.4457",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 96.4457H56.1057C56.3584 96.4457 56.5627 96.2414 56.5627 95.9887V93.3076C56.5627 93.0549 56.3584 92.8506 56.1057 92.8506H53.561C53.3083 92.8506 53.104 93.0549 53.104 93.3076V95.9887C53.104 96.2414 53.3083 96.4457 53.561 96.4457",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 96.4457H50.2651C50.5178 96.4457 50.7228 96.2414 50.7228 95.9887V93.3076C50.7228 93.0549 50.5178 92.8506 50.2651 92.8506H47.7204C47.4684 92.8506 47.2634 93.0549 47.2634 93.3076V95.9887C47.2634 96.2414 47.4684 96.4457 47.7204 96.4457",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8801 96.4457H44.4248C44.6774 96.4457 44.8818 96.2414 44.8818 95.9887V93.3076C44.8818 93.0549 44.6774 92.8506 44.4248 92.8506H41.8801C41.6274 92.8506 41.4231 93.0549 41.4231 93.3076V95.9887C41.4231 96.2414 41.6274 96.4457 41.8801 96.4457",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 20,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12891 209.893H248.004V20.7432H5.12891V209.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9448 88.1596H62.4035V84.5645H58.9448V88.1596Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 88.1596H56.1057C56.3584 88.1596 56.5627 87.9552 56.5627 87.7026V85.0214C56.5627 84.7688 56.3584 84.5645 56.1057 84.5645H53.561C53.3083 84.5645 53.104 84.7688 53.104 85.0214V87.7026C53.104 87.9552 53.3083 88.1596 53.561 88.1596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 88.1596H50.2651C50.5178 88.1596 50.7228 87.9552 50.7228 87.7026V85.0214C50.7228 84.7688 50.5178 84.5645 50.2651 84.5645H47.7204C47.4684 84.5645 47.2634 84.7688 47.2634 85.0214V87.7026C47.2634 87.9552 47.4684 88.1596 47.7204 88.1596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8801 88.1596H44.4248C44.6774 88.1596 44.8818 87.9552 44.8818 87.7026V85.0214C44.8818 84.7688 44.6774 84.5645 44.4248 84.5645H41.8801C41.6274 84.5645 41.4231 84.7688 41.4231 85.0214V87.7026C41.4231 87.9552 41.6274 88.1596 41.8801 88.1596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9448 79.9994H62.4035V76.4043H58.9448V79.9994Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.561 79.9994H56.1057C56.3584 79.9994 56.5627 79.7951 56.5627 79.5424V76.8613C56.5627 76.6086 56.3584 76.4043 56.1057 76.4043H53.561C53.3083 76.4043 53.104 76.6086 53.104 76.8613V79.5424C53.104 79.7951 53.3083 79.9994 53.561 79.9994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7204 79.9994H50.2651C50.5178 79.9994 50.7228 79.7951 50.7228 79.5424V76.8613C50.7228 76.6086 50.5178 76.4043 50.2651 76.4043H47.7204C47.4684 76.4043 47.2634 76.6086 47.2634 76.8613V79.5424C47.2634 79.7951 47.4684 79.9994 47.7204 79.9994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8801 79.9994H44.4248C44.6774 79.9994 44.8818 79.7951 44.8818 79.5424V76.8613C44.8818 76.6086 44.6774 76.4043 44.4248 76.4043H41.8801C41.6274 76.4043 41.4231 76.6086 41.4231 76.8613V79.5424C41.4231 79.7951 41.6274 79.9994 41.8801 79.9994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4814 70.1772H59.0261C59.2788 70.1772 59.4838 69.9728 59.4838 69.7202V67.039C59.4838 66.7864 59.2788 66.582 59.0261 66.582H56.4814C56.2294 66.582 56.0244 66.7864 56.0244 67.039V69.7202C56.0244 69.9728 56.2294 70.1772 56.4814 70.1772",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6408 70.1772H53.1855C53.4382 70.1772 53.6425 69.9728 53.6425 69.7202V67.039C53.6425 66.7864 53.4382 66.582 53.1855 66.582H50.6408C50.3882 66.582 50.1838 66.7864 50.1838 67.039V69.7202C50.1838 69.9728 50.3882 70.1772 50.6408 70.1772",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8002 70.1772H47.8019V66.582H44.3433V69.7202C44.3433 69.9728 44.5476 70.1772 44.8002 70.1772",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4814 63.9106H59.0261C59.2788 63.9106 59.4838 63.7062 59.4838 63.4536V60.7724C59.4838 60.5198 59.2788 60.3154 59.0261 60.3154H56.4814C56.2294 60.3154 56.0244 60.5198 56.0244 60.7724V63.4536C56.0244 63.7062 56.2294 63.9106 56.4814 63.9106",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6408 63.9106H53.1855C53.4382 63.9106 53.6425 63.7062 53.6425 63.4536V60.7724C53.6425 60.5198 53.4382 60.3154 53.1855 60.3154H50.6408C50.3882 60.3154 50.1838 60.5198 50.1838 60.7724V63.4536C50.1838 63.7062 50.3882 63.9106 50.6408 63.9106",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8002 63.9106H47.345C47.5976 63.9106 47.8019 63.7062 47.8019 63.4536V60.7724C47.8019 60.5198 47.5976 60.3154 47.345 60.3154H44.8002C44.5476 60.3154 44.3433 60.5198 44.3433 60.7724V63.4536C44.3433 63.7062 44.5476 63.9106 44.8002 63.9106",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4814 57.6449H59.0261C59.2788 57.6449 59.4838 57.4406 59.4838 57.188V54.5061C59.4838 54.2541 59.2788 54.0498 59.0261 54.0498H56.4814C56.2294 54.0498 56.0244 54.2541 56.0244 54.5061V57.188C56.0244 57.4406 56.2294 57.6449 56.4814 57.6449",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6408 57.6449H53.1855C53.4382 57.6449 53.6425 57.4406 53.6425 57.188V54.5061C53.6425 54.2541 53.4382 54.0498 53.1855 54.0498H50.6408C50.3882 54.0498 50.1838 54.2541 50.1838 54.5061V57.188C50.1838 57.4406 50.3882 57.6449 50.6408 57.6449",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8002 57.6449H47.345C47.5976 57.6449 47.8019 57.4406 47.8019 57.188V54.5061C47.8019 54.2541 47.5976 54.0498 47.345 54.0498H44.8002C44.5476 54.0498 44.3433 54.2541 44.3433 54.5061V57.188C44.3433 57.4406 44.5476 57.6449 44.8002 57.6449",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4814 51.3783H59.0261C59.2788 51.3783 59.4838 51.174 59.4838 50.9213V48.2402C59.4838 47.9875 59.2788 47.7832 59.0261 47.7832H56.4814C56.2294 47.7832 56.0244 47.9875 56.0244 48.2402V50.9213C56.0244 51.174 56.2294 51.3783 56.4814 51.3783",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6408 51.3783H53.1855C53.4382 51.3783 53.6425 51.174 53.6425 50.9213V48.2402C53.6425 47.9875 53.4382 47.7832 53.1855 47.7832H50.6408C50.3882 47.7832 50.1838 47.9875 50.1838 48.2402V50.9213C50.1838 51.174 50.3882 51.3783 50.6408 51.3783",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8002 51.3783H47.345C47.5976 51.3783 47.8019 51.174 47.8019 50.9213V48.2402C47.8019 47.9875 47.5976 47.7832 47.345 47.7832H44.8002C44.5476 47.7832 44.3433 47.9875 44.3433 48.2402V50.9213C44.3433 51.174 44.5476 51.3783 44.8002 51.3783",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3613 99.3725V71.7402H62.353V44.1093H58.3328V32.1396H55.4545V44.1093H49.4106V32.1396H46.5323V44.1093H41.5839V71.7402H37.5827V99.3725H31.3384V133.333H72.1911V99.3725H66.3613Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4172 34.0234V22.5107",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3394 33.9902V22.4775",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.726 132.028H34.8842C35.1368 132.028 35.3418 131.824 35.3418 131.571V74.9267C35.3418 74.6741 35.1368 74.4697 34.8842 74.4697H18.726C18.4734 74.4697 18.269 74.6741 18.269 74.9267V131.571C18.269 131.824 18.4734 132.028 18.726 132.028",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 20,
    width: 244,
    height: 190
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12891 209.893H248.004V20.7432H5.12891V209.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7334 132.029H32.8062V74.4707H15.7334V132.029Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7334 132.029H32.8062V74.4707H15.7334V132.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7512 131.849H30.9093C31.162 131.849 31.367 131.644 31.367 131.392V74.747C31.367 74.495 31.162 74.29 30.9093 74.29H14.7512C14.4985 74.29 14.2942 74.495 14.2942 74.747V131.392C14.2942 131.644 14.4985 131.849 14.7512 131.849Z",
    stroke: "#0A2A49",
    strokeWidth: 0.773602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4592 113.829H29.2892V111.132C29.2892 110.88 29.0849 110.675 28.8323 110.675H26.4592V113.829Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 113.829H24.4547C24.7067 113.829 24.9111 113.625 24.9111 113.372V111.132C24.9111 110.88 24.7067 110.675 24.4547 110.675H22.538C22.2854 110.675 22.0811 110.88 22.0811 111.132V113.372C22.0811 113.625 22.2854 113.829 22.538 113.829",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7031 113.829H20.5331V110.675H17.7031V113.829Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 107.554H28.8327C29.0847 107.554 29.2896 107.35 29.2896 107.097V104.857C29.2896 104.604 29.0847 104.399 28.8327 104.399H26.916C26.664 104.399 26.459 104.604 26.459 104.857V107.097C26.459 107.35 26.664 107.554 26.916 107.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 107.554H24.4547C24.7067 107.554 24.9111 107.35 24.9111 107.097V104.857C24.9111 104.604 24.7067 104.399 24.4547 104.399H22.538C22.2854 104.399 22.0811 104.604 22.0811 104.857V107.097C22.0811 107.35 22.2854 107.554 22.538 107.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 107.554H20.0762C20.3288 107.554 20.5331 107.35 20.5331 107.097V104.857C20.5331 104.604 20.3288 104.399 20.0762 104.399H18.1601C17.9075 104.399 17.7031 104.604 17.7031 104.857V107.097C17.7031 107.35 17.9075 107.554 18.1601 107.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 126.493H28.8327C29.0847 126.493 29.2896 126.289 29.2896 126.036V123.796C29.2896 123.544 29.0847 123.339 28.8327 123.339H26.916C26.664 123.339 26.459 123.544 26.459 123.796V126.036C26.459 126.289 26.664 126.493 26.916 126.493",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 126.493H24.4547C24.7067 126.493 24.9111 126.289 24.9111 126.036V123.796C24.9111 123.544 24.7067 123.339 24.4547 123.339H22.538C22.2854 123.339 22.0811 123.544 22.0811 123.796V126.036C22.0811 126.289 22.2854 126.493 22.538 126.493",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 126.493H20.0762C20.3288 126.493 20.5331 126.289 20.5331 126.036V123.796C20.5331 123.544 20.3288 123.339 20.0762 123.339H18.1601C17.9075 123.339 17.7031 123.544 17.7031 123.796V126.036C17.7031 126.289 17.9075 126.493 18.1601 126.493",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 120.218H28.8327C29.0847 120.218 29.2896 120.014 29.2896 119.761V117.521C29.2896 117.268 29.0847 117.063 28.8327 117.063H26.916C26.664 117.063 26.459 117.268 26.459 117.521V119.761C26.459 120.014 26.664 120.218 26.916 120.218",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 120.218H24.4547C24.7067 120.218 24.9111 120.014 24.9111 119.761V117.521C24.9111 117.268 24.7067 117.063 24.4547 117.063H22.538C22.2854 117.063 22.0811 117.268 22.0811 117.521V119.761C22.0811 120.014 22.2854 120.218 22.538 120.218",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 120.218H20.0762C20.3288 120.218 20.5331 120.014 20.5331 119.761V117.521C20.5331 117.268 20.3288 117.063 20.0762 117.063H18.1601C17.9075 117.063 17.7031 117.268 17.7031 117.521V119.761C17.7031 120.014 17.9075 120.218 18.1601 120.218",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4595 101.278H29.2895V98.124H26.4595V101.278Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 101.278H24.4547C24.7067 101.278 24.9111 101.074 24.9111 100.822V98.5817C24.9111 98.329 24.7067 98.124 24.4547 98.124H22.538C22.2854 98.124 22.0811 98.329 22.0811 98.5817V100.822C22.0811 101.074 22.2854 101.278 22.538 101.278",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 101.278H20.0762C20.3288 101.278 20.5331 101.074 20.5331 100.822V98.5817C20.5331 98.329 20.3288 98.124 20.0762 98.124H18.1601C17.9075 98.124 17.7031 98.329 17.7031 98.5817V100.822C17.7031 101.074 17.9075 101.278 18.1601 101.278",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 95.0041H28.8327C29.0847 95.0041 29.2896 94.7997 29.2896 94.5471V92.3072C29.2896 92.0546 29.0847 91.8496 28.8327 91.8496H26.916C26.664 91.8496 26.459 92.0546 26.459 92.3072V94.5471C26.459 94.7997 26.664 95.0041 26.916 95.0041",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 95.0041H24.4547C24.7067 95.0041 24.9111 94.7997 24.9111 94.5471V92.3072C24.9111 92.0546 24.7067 91.8496 24.4547 91.8496H22.538C22.2854 91.8496 22.0811 92.0546 22.0811 92.3072V94.5471C22.0811 94.7997 22.2854 95.0041 22.538 95.0041",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 95.0041H20.0762C20.3288 95.0041 20.5331 94.7997 20.5331 94.5471V92.3072C20.5331 92.0546 20.3288 91.8496 20.0762 91.8496H18.1601C17.9075 91.8496 17.7031 92.0546 17.7031 92.3072V94.5471C17.7031 94.7997 17.9075 95.0041 18.1601 95.0041",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 88.7287H28.8327C29.0847 88.7287 29.2896 88.5244 29.2896 88.2717V86.0319C29.2896 85.7792 29.0847 85.5742 28.8327 85.5742H26.916C26.664 85.5742 26.459 85.7792 26.459 86.0319V88.2717C26.459 88.5244 26.664 88.7287 26.916 88.7287",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 88.7287H24.4547C24.7067 88.7287 24.9111 88.5244 24.9111 88.2717V86.0319C24.9111 85.7792 24.7067 85.5742 24.4547 85.5742H22.538C22.2854 85.5742 22.0811 85.7792 22.0811 86.0319V88.2717C22.0811 88.5244 22.2854 88.7287 22.538 88.7287",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1601 88.7287H20.0762C20.3288 88.7287 20.5331 88.5244 20.5331 88.2717V86.0319C20.5331 85.7792 20.3288 85.5742 20.0762 85.5742H18.1601C17.9075 85.5742 17.7031 85.7792 17.7031 86.0319V88.2717C17.7031 88.5244 17.9075 88.7287 18.1601 88.7287",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.916 82.4533H28.8327C29.0847 82.4533 29.2896 82.249 29.2896 81.9963V79.7565C29.2896 79.5038 29.0847 79.2988 28.8327 79.2988H26.916C26.664 79.2988 26.459 79.5038 26.459 79.7565V81.9963C26.459 82.249 26.664 82.4533 26.916 82.4533",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.538 82.4533H24.4547C24.7067 82.4533 24.9111 82.249 24.9111 81.9963V79.7565C24.9111 79.5038 24.7067 79.2988 24.4547 79.2988H22.538C22.2854 79.2988 22.0811 79.5038 22.0811 79.7565V81.9963C22.0811 82.249 22.2854 82.4533 22.538 82.4533",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7031 82.4533H20.0762C20.3288 82.4533 20.5331 82.249 20.5331 81.9963V79.2988H17.7031V82.4533Z",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.127 163.115C286.888 159.688 291.924 157.992 292.288 154.582C292.467 152.916 291.263 151.202 289.632 150.797C289.035 150.649 288.41 150.682 287.827 150.862C286.823 151.171 285.82 150.366 285.928 149.32L286.746 141.459C286.886 140.119 285.278 139.316 284.301 140.238C283.508 140.987 282.196 140.615 281.901 139.558L280.198 133.44C279.956 132.573 278.992 132.122 278.181 132.503C277.308 132.913 276.142 132.955 275.266 132.496C273.584 131.614 272.605 129.82 271.187 128.555C269.768 127.291 267.227 126.751 266.196 128.329C269.904 130.635 274.106 133.87 273.689 138.193C273.566 139.475 273.013 140.656 272.203 141.654C271.503 142.516 271.999 143.815 273.1 144.002C274.145 144.179 275.159 144.492 276.096 144.994C278.089 146.063 279.664 148.12 279.666 150.371C279.668 151.872 278.816 153.355 277.581 154.141C276.671 154.72 276.641 156.055 277.582 156.597C278.515 157.134 279.576 157.457 280.646 157.527C281.704 157.597 282.316 158.775 281.796 159.692C281.06 160.994 280.343 162.3 279.986 163.747C278.8 168.544 282.93 175.697 288.583 174.177C296.315 172.097 287.359 166.434 287.127 163.115",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.16 159.418C288.002 158.988 290.3 159.929 291.539 158.323C292.017 157.703 292.143 156.879 291.963 156.114C291.521 154.228 289.993 153.129 288.935 151.677C288.927 151.666 288.92 151.655 288.912 151.644C288.128 150.552 289.284 149.147 290.522 149.654C291.637 150.111 292.896 150.218 294.057 149.892C296.157 149.304 297.807 147.342 298.038 145.156C298.204 143.599 297.71 142.018 298.22 140.469C298.435 139.817 298.85 139.234 299.461 138.928C301.502 137.902 303.362 140.856 305.494 139.415C305.985 139.082 306.352 138.59 306.578 138.039C307.454 135.909 306.527 133.564 307.652 131.481C308.016 130.807 308.629 130.283 309.377 130.143C311.028 129.834 311.933 131.48 313.284 132.126C315.286 133.083 317.663 131.581 318.874 129.71C320.086 127.839 320.648 125.579 321.988 123.8C323.454 121.853 326.509 120.656 328.22 122.683C328.907 123.497 329.116 124.614 328.89 125.66C328.438 127.739 326.728 129.073 324.932 129.964C323.467 130.692 321.892 131.189 320.458 131.979C319.374 132.577 318.355 133.368 317.734 134.445C317.112 135.522 316.95 136.924 317.549 138.015C318.512 139.769 321.175 140.463 321.272 142.514C321.328 143.701 320.472 144.712 319.335 145.022C317.312 145.573 315.55 144.478 313.916 143.447C312.27 142.409 310.456 141.347 308.436 142.027C307.349 142.393 306.585 143.45 306.71 144.598C306.854 145.941 308.159 146.701 309.268 147.403C310.33 148.075 311.447 149.145 311.191 150.383C310.86 151.987 308.641 152.225 307.096 151.716C305.493 151.19 303.749 150.271 302.237 151.119C300.926 151.855 300.458 153.516 301.02 154.919C301.033 154.95 301.046 154.981 301.058 155.012C301.714 156.564 300.455 158.25 298.793 158.058L296.42 157.785C295.709 157.704 294.978 157.867 294.41 158.305C292.375 159.87 294.529 162.809 295.869 163.848C297.07 164.779 297.916 166.122 298.07 167.64C298.691 173.772 289.404 173.32 286.263 170.985C283.142 168.663 280.873 160.654 286.16 159.418",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.158 139.414C308.65 139.082 309.015 138.589 309.242 138.039C310.119 135.908 309.191 133.564 310.316 131.481C310.453 131.227 310.633 131.007 310.834 130.808C310.221 130.339 309.572 129.985 308.728 130.143C307.979 130.282 307.366 130.807 307.002 131.481C305.878 133.564 306.805 135.908 305.929 138.039C305.728 138.525 305.415 138.958 305.008 139.283C306.027 139.73 307.057 140.159 308.158 139.414",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.614 157.997L298.144 158.058C298.603 158.111 299.023 158.011 299.389 157.821L299.084 157.785C298.582 157.728 298.072 157.8 297.614 157.997",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.948 132.126C317.95 133.083 320.327 131.581 321.539 129.71C322.75 127.838 323.312 125.579 324.652 123.8C325.206 123.065 325.985 122.438 326.834 122.05C325.085 120.986 322.612 122.109 321.338 123.8C319.998 125.579 319.436 127.838 318.225 129.71C317.615 130.651 316.711 131.498 315.708 131.986C315.788 132.033 315.865 132.086 315.948 132.126",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.58 143.447C314.934 142.409 313.12 141.347 311.1 142.028C311 142.061 310.907 142.106 310.812 142.151C311.67 142.465 312.488 142.956 313.266 143.447C314.901 144.478 316.661 145.573 318.685 145.023C318.855 144.977 319.014 144.911 319.168 144.836C318.262 144.503 317.404 143.967 316.58 143.447",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.901 151.119C304.883 151.129 304.867 151.144 304.85 151.155C305.388 151.335 305.925 151.545 306.447 151.717C307.419 152.036 308.655 152.058 309.523 151.633C307.985 151.101 306.339 150.312 304.901 151.119",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.927 170.985C285.806 168.663 283.536 160.654 288.824 159.418C290.211 159.094 291.858 159.547 293.114 159.105C293.248 158.815 293.451 158.543 293.76 158.305C293.961 158.151 294.187 158.043 294.419 157.955C294.705 157.396 294.773 156.738 294.627 156.114C294.186 154.228 292.656 153.129 291.6 151.677C291.592 151.666 291.584 151.655 291.576 151.644C291.189 151.104 291.277 150.489 291.614 150.065C291.018 150.022 290.428 149.882 289.872 149.655C288.635 149.147 287.479 150.553 288.262 151.644C288.27 151.655 288.277 151.666 288.286 151.677C289.343 153.129 290.871 154.228 291.313 156.114C291.493 156.88 291.367 157.703 290.889 158.324C289.651 159.928 287.352 158.988 285.51 159.418C280.223 160.654 282.492 168.663 285.613 170.985C287.214 172.176 290.41 172.874 293.077 172.464C291.425 172.237 289.888 171.7 288.927 170.985",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.65 149.802C294.644 150.114 295.717 150.173 296.722 149.891C298.821 149.304 300.47 147.341 300.703 145.155C300.868 143.598 300.374 142.017 300.884 140.469C301.036 140.005 301.296 139.582 301.649 139.263C300.711 138.852 299.781 138.44 298.811 138.927C298.201 139.234 297.785 139.817 297.571 140.469C297.06 142.017 297.555 143.598 297.389 145.155C297.166 147.254 295.63 149.135 293.65 149.802",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.736 143.27C274.445 143.985 277.877 146.009 281.047 148.226C282.636 149.338 284.208 150.531 285.409 152.041C286.448 153.351 286.97 154.346 287.854 156.505C288.037 156.954 287.626 157.422 287.155 157.306C281.68 155.956 280.681 156.029 275.746 152.102C275.596 151.984 275.512 151.8 275.521 151.61C275.548 151.046 275.246 150.223 275.212 149.61C275.197 149.336 274.99 149.101 274.717 149.068C273.8 148.955 272.878 149.024 272.026 149.271C271.644 149.382 271.267 149.094 271.273 148.695C271.282 148.244 271.289 147.793 271.297 147.341C271.302 147.018 271.049 146.737 270.726 146.738C269.537 146.739 268.38 147.039 267.394 147.597C266.995 147.822 266.502 147.565 266.491 147.108C266.48 146.755 266.471 146.401 266.462 146.047C266.45 145.605 258.845 146.306 263.411 144.057C265.577 142.989 268.227 142.786 270.736 143.27",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.769 156.714C286.886 154.555 286.364 153.56 285.325 152.25C284.125 150.74 282.552 149.547 280.963 148.435C277.793 146.218 274.36 144.194 270.651 143.479C268.143 142.995 265.493 143.198 263.327 144.266C262.168 144.836 261.795 145.216 261.882 145.474C262.03 145.391 262.191 145.305 262.38 145.212C264.547 144.144 267.196 143.942 269.704 144.425C273.413 145.14 276.847 147.165 280.015 149.382C281.606 150.494 283.178 151.687 284.377 153.198C285.378 154.456 285.902 155.436 286.727 157.431C286.843 157.459 286.951 157.485 287.071 157.515C287.542 157.631 287.952 157.163 287.769 156.714",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.306 143.65C272.306 143.65 296.843 149.095 285.877 174.263",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.537 134.561C280.576 134.461 280.646 133.433 280.632 131.879C280.629 131.554 280.891 131.282 281.217 131.276C283.169 131.242 285.136 131.27 287.114 131.363C286.311 131.284 284.877 130.144 284.055 129.748C282.993 129.224 281.927 128.735 280.859 128.28C280.713 128.217 280.577 128.157 280.451 128.1C280.344 126.833 280.178 125.477 279.965 124.136C279.913 123.811 280.131 123.504 280.456 123.451C281.774 123.242 283.101 123.057 284.439 122.898C283.646 122.959 282.188 122.285 281.372 122.1C280.878 121.983 280.384 121.874 279.892 121.768C279.664 121.721 279.489 121.541 279.44 121.313C278.844 118.484 278.101 116.148 277.907 115.545C277.874 115.442 277.872 115.34 277.898 115.236C278.364 113.326 278.747 111.365 279.042 109.361C279.557 109.228 279.591 109.219 280.107 109.087C288.115 120.15 292.582 132.72 293.453 145.215C293.492 145.774 292.795 146.064 292.418 145.651C291.041 144.137 288.79 141.727 286.539 139.719C283.487 136.871 280.434 134.779 280.537 134.561",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.41 110.541C287.656 110.758 288.434 111.444 289.533 112.49C289.757 112.703 289.78 113.055 289.585 113.296C288.263 114.921 286.996 116.472 287.477 116.317C287.852 116.197 289.624 115.636 291.659 115.051C291.871 114.991 292.099 115.048 292.252 115.207C294.166 117.211 296.352 119.746 298.358 122.442C298.544 122.692 298.508 123.042 298.272 123.245C296.422 124.84 292.789 127.772 293.516 127.646C294.097 127.556 297.898 127.057 300.991 126.78C301.212 126.761 301.424 126.868 301.544 127.056C304.628 131.873 306.53 136.236 306.474 136.563C306.409 137.017 303.515 140.012 300.391 142.509C297.3 145.067 293.978 147.127 293.786 147.108C293.758 147.104 293.676 147.031 293.549 146.901C292.98 133.93 288.528 120.803 280.254 109.291C279.926 108.836 280.344 108.213 280.885 108.363C282.992 108.948 285.106 109.635 287.218 110.425C287.288 110.452 287.354 110.491 287.41 110.541",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.968 109.698C279.453 109.831 279.42 109.84 278.904 109.972C278.879 110.137 278.846 110.295 278.82 110.459C286.704 121.368 291.139 133.736 292.089 146.054C292.152 146.122 292.221 146.197 292.28 146.262C292.658 146.677 293.354 146.385 293.315 145.827C292.444 133.331 287.978 120.761 279.968 109.698",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64 175.052C285.64 175.052 293.445 163.43 293.529 146.965C293.591 135.076 289.47 121.292 280.039 109.173",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.666 139.5C320.028 141.682 311.795 145.991 304.867 151.956C310.578 152.063 316.187 153.543 321.125 156.244C323.459 157.521 325.745 159.1 328.422 159.359C329.067 156.794 328.832 154.052 327.766 151.739C330.08 152.648 332.392 153.557 334.705 154.465C335.646 154.727 336.724 154.072 337.186 153.144C337.646 152.217 337.576 151.109 337.218 150.18C336.859 149.251 336.243 148.466 335.62 147.71C337.596 148.439 339.573 149.167 341.549 149.896C341.981 150.056 342.42 150.216 342.884 150.253C344.142 150.352 345.332 149.536 346.358 148.708C348.576 146.918 350.611 144.882 352.418 142.654C352.916 142.04 354.671 140.341 354.371 139.486C354.133 138.809 351.889 138.719 351.263 138.611C346.49 137.778 341.575 137.606 336.688 138.094C333.996 138.362 331.312 138.831 328.666 139.5",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.666 141.729C331.312 141.06 333.996 140.591 336.688 140.322C341.575 139.835 346.49 140.007 351.263 140.84C351.7 140.916 352.918 140.987 353.699 141.252C354.16 140.646 354.52 140.011 354.371 139.585C354.133 138.909 351.889 138.819 351.263 138.709C346.49 137.876 341.575 137.704 336.688 138.193C333.996 138.461 331.312 138.93 328.666 139.598C320.028 141.781 311.795 146.09 304.867 152.054C305.686 152.069 306.501 152.121 307.313 152.192C313.699 147.259 321.023 143.66 328.666 141.729",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.388 174.162C286.388 174.162 307.416 129.607 354.371 139.487",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1459 153.741C46.4444 151.48 47.5716 148.828 49.0236 146.583C50.8014 143.834 53.0795 141.677 55.143 140.7C55.6909 140.439 56.232 141.08 55.8902 141.581C54.9471 142.958 53.92 144.23 52.8539 145.335C52.5333 145.666 52.7139 146.224 53.166 146.319L53.9539 146.484C54.3958 146.577 54.5739 147.112 54.2822 147.457C53.6164 148.246 52.909 148.93 52.2016 149.472C51.8497 149.743 51.9031 150.282 52.3026 150.475L53.339 150.973C53.691 151.143 53.7885 151.598 53.5332 151.893C52.691 152.868 51.144 154.787 50.9065 155.051C50.1339 155.913 48.7853 157.697 47.9804 157.993C46.3689 158.588 45.905 155.565 46.1459 153.741",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0394 153.741C48.3379 151.48 49.4651 148.828 50.918 146.583C52.4625 144.194 54.1647 142.391 55.9967 141.282C55.9967 140.908 55.7719 140.514 55.3801 140.7C53.3166 141.677 51.0376 143.835 49.2607 146.583C47.8087 148.828 46.6806 151.48 46.3821 153.741C46.1421 155.565 46.606 158.588 48.2175 157.994C48.3676 157.938 48.5406 157.819 48.7213 157.676C48.0496 156.874 47.8706 155.017 48.0394 153.741",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1435 140.699C55.1435 140.699 39.4519 149.288 48.2845 169.571",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.799 140.813C28.8219 146.068 30.4147 151.578 33.2382 156.307C33.5469 156.822 34.3544 156.592 34.3408 155.99C34.2195 150.693 36.0049 145.696 39.2422 142.399C39.534 142.103 39.4611 141.614 39.0862 141.436C38.7249 141.265 38.3627 141.094 38.0014 140.922C37.6045 140.735 37.5417 140.196 37.8844 139.922C38.6952 139.274 39.506 138.626 40.316 137.978C40.5899 137.76 40.6154 137.352 40.3711 137.101L37.8453 134.506C37.5739 134.228 37.6392 133.768 37.9776 133.576C39.3338 132.805 40.69 132.035 42.0462 131.265C42.3727 131.08 42.4372 130.649 42.1955 130.361C40.1667 127.949 39.1405 125.17 38.5298 122.169C38.4416 121.738 37.9344 121.531 37.5892 121.803C32.3001 125.969 28.743 132.941 28.799 140.813",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6975 141.522C30.644 133.992 33.8255 127.357 38.7388 123.142C38.7244 123.076 38.704 122.994 38.6904 122.927C38.6031 122.496 38.1765 122.241 37.8304 122.513C32.5422 126.679 28.9842 133.651 29.0402 141.522C29.0631 146.777 30.6559 152.287 33.4803 157.016C33.7881 157.532 34.5964 157.301 34.582 156.7C34.5769 156.478 34.5947 156.261 34.5964 156.04C32.1198 151.536 30.7187 146.423 30.6975 141.522",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5894 121.804C37.5894 121.804 12.1348 143.16 48.2413 171.984",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8214 122.621C11.2642 127.71 12.6102 133.788 14.3438 138.611C15.9087 142.962 18.4794 146.505 21.4471 149.206C21.8202 149.547 22.4258 149.305 22.4445 148.801C22.6167 144.204 23.9567 139.639 26.1941 136.07C26.3612 135.804 26.3095 135.437 26.0406 135.273C24.5708 134.382 22.1222 136.304 21.129 134.456C20.5565 133.388 21.051 131.733 21.8881 130.972C22.7261 130.211 23.7718 130.099 24.7642 130.004C25.6539 129.918 26.5902 129.802 27.368 129.208C27.5554 129.065 27.6182 128.806 27.558 128.577C27.072 126.712 24.4953 126.83 23.8176 124.889C23.3215 123.465 24.2222 121.667 25.3451 121.117C26.1806 120.706 27.0703 120.783 27.943 120.988C28.3561 121.084 28.7352 120.725 28.6572 120.307C28.2602 118.18 26.921 113.145 21.5149 113.663C16.4506 114.149 14.0181 118.71 12.8214 122.621",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6123 138.611C14.8787 133.788 13.5327 127.711 15.0899 122.621C16.2637 118.784 18.6352 114.33 23.5086 113.704C22.976 113.624 22.3942 113.602 21.7521 113.663C16.687 114.149 14.2545 118.71 13.0586 122.621C11.5005 127.711 12.8474 133.788 14.581 138.611C16.145 142.962 18.7166 146.505 21.6843 149.207C22.0574 149.546 22.6622 149.305 22.6817 148.802C22.6885 148.616 22.7088 148.433 22.7198 148.248C20.1771 145.684 17.9982 142.466 16.6123 138.611",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.657 120.307C28.657 120.307 27.2949 110.206 18.4182 114.467C18.4182 114.467 10.8442 118.963 12.5015 131.034C12.5015 131.034 11.7908 145.946 43.2706 171.036",
    stroke: "white",
    strokeWidth: 0.932963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9009 169.462C17.9374 167.536 18.4056 164.197 16.9663 161.853C13.1903 155.709 1.17971 161.384 -2.55129 155.212C-4.95409 151.238 -1.75743 144.933 -5.34679 141.986C-6.43835 141.09 -7.90226 140.809 -9.13886 140.126C-10.3746 139.441 -11.445 137.965 -10.853 136.682C-10.0387 134.917 -7.40524 135.523 -5.67163 136.403L10.4033 144.563C14.3438 146.563 18.392 148.647 21.263 152.006C23.1052 154.161 24.413 156.79 26.5792 158.619C29.0829 160.735 32.4068 161.52 35.5246 162.533C38.885 163.624 49.6904 166.955 50.9711 170.674C52.016 173.707 48.5055 176.677 45.4539 176.605C40.5685 176.489 38.248 169.953 33.0769 169.221C29.0405 168.651 23.3461 172.842 19.9009 169.462",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2288 175.067C42.3435 174.951 40.0229 168.415 34.8518 167.683C30.8154 167.113 25.1218 171.304 21.6766 167.924C19.7123 165.997 20.1814 162.658 18.7412 160.314C14.9653 154.17 2.95548 159.845 -0.776369 153.673C-3.17832 149.699 0.0183458 143.394 -3.57102 140.448C-4.66343 139.551 -6.12733 139.271 -7.36308 138.587C-8.3885 138.02 -9.28414 136.909 -9.22816 135.814C-9.93891 135.905 -10.5352 136.23 -10.8532 136.919C-11.4452 138.202 -10.3749 139.678 -9.13826 140.362C-7.90251 141.046 -6.4386 141.327 -5.34619 142.223C-1.75683 145.17 -4.9535 151.475 -2.55069 155.449C1.18031 161.62 13.1909 155.945 16.966 162.089C18.4062 164.433 17.9372 167.773 19.9006 169.699C23.3467 173.08 29.0403 168.887 33.0766 169.459C38.2478 170.19 40.5683 176.726 45.4536 176.842C47.3942 176.888 49.5146 175.702 50.5374 174.054C49.5392 174.705 48.3534 175.094 47.2288 175.067",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3869 152.507C61.4149 151.472 61.1748 150.303 59.9026 150.169C58.7008 150.043 57.2072 150.995 56.521 151.997C55.8349 153.001 55.7272 154.035 55.544 155.043C55.2132 156.872 54.5813 158.744 53.6687 160.603C53.1361 161.687 52.2803 162.949 50.8741 163.408C49.3779 163.898 48.1965 163.175 47.4883 162.384C44.5901 159.147 44.5986 154.439 42.9761 150.519C42.703 149.858 42.1432 149.139 41.1077 149.376C40.4291 149.532 39.8363 150.078 39.5996 150.599C39.363 151.12 39.4105 151.621 39.5004 152.087C40.3418 156.464 44.5121 159.625 44.0346 164.354C42.7963 164.89 41.502 164.728 40.5699 164.322C39.637 163.916 38.9271 163.296 37.9737 162.913C37.0196 162.53 35.6787 162.424 34.4675 163.02C33.0977 163.693 32.3929 165.077 32.6805 166.037C32.9671 166.997 34.0316 167.571 35.2461 167.841C36.4607 168.109 37.8389 168.121 39.1578 168.226C40.4758 168.331 41.7811 168.546 42.6564 169.167C43.4401 169.723 43.8158 170.556 44.2441 171.339C44.8522 172.453 46.4069 174.317 48.7834 173.145C49.6689 172.708 50.3542 171.85 51.0098 171.24C51.8673 170.444 52.7171 169.655 53.5033 168.823C56.5821 165.565 58.878 161.993 60.1774 158.453C60.9178 156.436 61.3351 154.431 61.3869 152.507",
    fill: "#DCF0EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.9777,
    y1: 23.6247,
    x2: 23.9777,
    y2: 160.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CD3CD",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileConfirmation);
export default __webpack_public_path__ + "static/media/mobile_confirmation.1ca100ba9e1a4a41d9adbe945e2f8f3c.svg";
export { ForwardRef as ReactComponent };